export const PRACTICE_ROUNDS_TWENTYONE_MOCK = [
  {
    status: 200,
    body: {
      status: 200,
      msg: 'Practice round',
      data: {
        opponentName: 'WhiteGangsta',
        opponentScore: 1880,
        secrets: [
          {
            index: 0,
            value: 52,
          },
          {
            index: 1,
            value: 45,
          },
          {
            index: 2,
            value: 1,
          },
          {
            index: 3,
            value: 11,
          },
          {
            index: 4,
            value: 9,
          },
          {
            index: 5,
            value: 14,
          },
          {
            index: 6,
            value: 51,
          },
          {
            index: 7,
            value: 48,
          },
          {
            index: 8,
            value: 40,
          },
          {
            index: 9,
            value: 34,
          },
          {
            index: 10,
            value: 30,
          },
          {
            index: 11,
            value: 3,
          },
          {
            index: 12,
            value: 37,
          },
          {
            index: 13,
            value: 25,
          },
          {
            index: 14,
            value: 43,
          },
          {
            index: 15,
            value: 53,
          },
          {
            index: 16,
            value: 22,
          },
          {
            index: 17,
            value: 6,
          },
          {
            index: 18,
            value: 18,
          },
          {
            index: 19,
            value: 28,
          },
          {
            index: 20,
            value: 47,
          },
          {
            index: 21,
            value: 35,
          },
          {
            index: 22,
            value: 38,
          },
          {
            index: 23,
            value: 10,
          },
          {
            index: 24,
            value: 32,
          },
          {
            index: 25,
            value: 26,
          },
          {
            index: 26,
            value: 7,
          },
          {
            index: 27,
            value: 4,
          },
          {
            index: 28,
            value: 17,
          },
          {
            index: 29,
            value: 16,
          },
          {
            index: 30,
            value: 36,
          },
          {
            index: 31,
            value: 19,
          },
          {
            index: 32,
            value: 49,
          },
          {
            index: 33,
            value: 41,
          },
          {
            index: 34,
            value: 27,
          },
          {
            index: 35,
            value: 50,
          },
          {
            index: 36,
            value: 44,
          },
          {
            index: 37,
            value: 5,
          },
          {
            index: 38,
            value: 24,
          },
          {
            index: 39,
            value: 23,
          },
          {
            index: 40,
            value: 0,
          },
          {
            index: 41,
            value: 33,
          },
          {
            index: 42,
            value: 39,
          },
          {
            index: 43,
            value: 31,
          },
          {
            index: 44,
            value: 29,
          },
          {
            index: 45,
            value: 8,
          },
          {
            index: 46,
            value: 12,
          },
          {
            index: 47,
            value: 46,
          },
          {
            index: 48,
            value: 13,
          },
          {
            index: 49,
            value: 42,
          },
          {
            index: 50,
            value: 21,
          },
          {
            index: 51,
            value: 20,
          },
        ],
      },
    },
  },
  {
    status: 200,
    body: {
      status: 200,
      msg: 'Practice round',
      data: {
        opponentName: 'pewoili',
        opponentScore: 3050,
        secrets: [
          {
            index: 0,
            value: 31,
          },
          {
            index: 1,
            value: 39,
          },
          {
            index: 2,
            value: 22,
          },
          {
            index: 3,
            value: 2,
          },
          {
            index: 4,
            value: 12,
          },
          {
            index: 5,
            value: 40,
          },
          {
            index: 6,
            value: 42,
          },
          {
            index: 7,
            value: 25,
          },
          {
            index: 8,
            value: 20,
          },
          {
            index: 9,
            value: 44,
          },
          {
            index: 10,
            value: 34,
          },
          {
            index: 11,
            value: 50,
          },
          {
            index: 12,
            value: 52,
          },
          {
            index: 13,
            value: 17,
          },
          {
            index: 14,
            value: 51,
          },
          {
            index: 15,
            value: 19,
          },
          {
            index: 16,
            value: 35,
          },
          {
            index: 17,
            value: 36,
          },
          {
            index: 18,
            value: 28,
          },
          {
            index: 19,
            value: 37,
          },
          {
            index: 20,
            value: 16,
          },
          {
            index: 21,
            value: 10,
          },
          {
            index: 22,
            value: 45,
          },
          {
            index: 23,
            value: 47,
          },
          {
            index: 24,
            value: 49,
          },
          {
            index: 25,
            value: 13,
          },
          {
            index: 26,
            value: 41,
          },
          {
            index: 27,
            value: 18,
          },
          {
            index: 28,
            value: 4,
          },
          {
            index: 29,
            value: 14,
          },
          {
            index: 30,
            value: 23,
          },
          {
            index: 31,
            value: 43,
          },
          {
            index: 32,
            value: 0,
          },
          {
            index: 33,
            value: 46,
          },
          {
            index: 34,
            value: 7,
          },
          {
            index: 35,
            value: 21,
          },
          {
            index: 36,
            value: 38,
          },
          {
            index: 37,
            value: 29,
          },
          {
            index: 38,
            value: 30,
          },
          {
            index: 39,
            value: 48,
          },
          {
            index: 40,
            value: 24,
          },
          {
            index: 41,
            value: 9,
          },
          {
            index: 42,
            value: 11,
          },
          {
            index: 43,
            value: 32,
          },
          {
            index: 44,
            value: 1,
          },
          {
            index: 45,
            value: 53,
          },
          {
            index: 46,
            value: 26,
          },
          {
            index: 47,
            value: 3,
          },
          {
            index: 48,
            value: 6,
          },
          {
            index: 49,
            value: 8,
          },
          {
            index: 50,
            value: 5,
          },
          {
            index: 51,
            value: 27,
          },
        ],
      },
    },
  },
  {
    status: 200,
    body: {
      status: 200,
      msg: 'Practice round',
      data: {
        opponentName: 'Shirinilam',
        opponentScore: 4350,
        secrets: [
          {
            index: 0,
            value: 13,
          },
          {
            index: 1,
            value: 48,
          },
          {
            index: 2,
            value: 27,
          },
          {
            index: 3,
            value: 19,
          },
          {
            index: 4,
            value: 3,
          },
          {
            index: 5,
            value: 24,
          },
          {
            index: 6,
            value: 51,
          },
          {
            index: 7,
            value: 36,
          },
          {
            index: 8,
            value: 37,
          },
          {
            index: 9,
            value: 53,
          },
          {
            index: 10,
            value: 14,
          },
          {
            index: 11,
            value: 42,
          },
          {
            index: 12,
            value: 47,
          },
          {
            index: 13,
            value: 21,
          },
          {
            index: 14,
            value: 5,
          },
          {
            index: 15,
            value: 40,
          },
          {
            index: 16,
            value: 39,
          },
          {
            index: 17,
            value: 18,
          },
          {
            index: 18,
            value: 32,
          },
          {
            index: 19,
            value: 44,
          },
          {
            index: 20,
            value: 15,
          },
          {
            index: 21,
            value: 50,
          },
          {
            index: 22,
            value: 10,
          },
          {
            index: 23,
            value: 1,
          },
          {
            index: 24,
            value: 52,
          },
          {
            index: 25,
            value: 45,
          },
          {
            index: 26,
            value: 33,
          },
          {
            index: 27,
            value: 16,
          },
          {
            index: 28,
            value: 2,
          },
          {
            index: 29,
            value: 0,
          },
          {
            index: 30,
            value: 43,
          },
          {
            index: 31,
            value: 30,
          },
          {
            index: 32,
            value: 26,
          },
          {
            index: 33,
            value: 35,
          },
          {
            index: 34,
            value: 25,
          },
          {
            index: 35,
            value: 46,
          },
          {
            index: 36,
            value: 31,
          },
          {
            index: 37,
            value: 7,
          },
          {
            index: 38,
            value: 29,
          },
          {
            index: 39,
            value: 28,
          },
          {
            index: 40,
            value: 6,
          },
          {
            index: 41,
            value: 20,
          },
          {
            index: 42,
            value: 23,
          },
          {
            index: 43,
            value: 49,
          },
          {
            index: 44,
            value: 34,
          },
          {
            index: 45,
            value: 38,
          },
          {
            index: 46,
            value: 4,
          },
          {
            index: 47,
            value: 8,
          },
          {
            index: 48,
            value: 22,
          },
          {
            index: 49,
            value: 11,
          },
          {
            index: 50,
            value: 17,
          },
          {
            index: 51,
            value: 12,
          },
        ],
      },
    },
  },
  {
    status: 200,
    body: {
      status: 200,
      msg: 'Practice round',
      data: {
        opponentName: 'BabyG',
        opponentScore: 310,
        secrets: [
          {
            index: 0,
            value: 39,
          },
          {
            index: 1,
            value: 0,
          },
          {
            index: 2,
            value: 41,
          },
          {
            index: 3,
            value: 16,
          },
          {
            index: 4,
            value: 49,
          },
          {
            index: 5,
            value: 19,
          },
          {
            index: 6,
            value: 40,
          },
          {
            index: 7,
            value: 50,
          },
          {
            index: 8,
            value: 44,
          },
          {
            index: 9,
            value: 15,
          },
          {
            index: 10,
            value: 25,
          },
          {
            index: 11,
            value: 48,
          },
          {
            index: 12,
            value: 8,
          },
          {
            index: 13,
            value: 4,
          },
          {
            index: 14,
            value: 18,
          },
          {
            index: 15,
            value: 35,
          },
          {
            index: 16,
            value: 7,
          },
          {
            index: 17,
            value: 52,
          },
          {
            index: 18,
            value: 2,
          },
          {
            index: 19,
            value: 14,
          },
          {
            index: 20,
            value: 13,
          },
          {
            index: 21,
            value: 27,
          },
          {
            index: 22,
            value: 43,
          },
          {
            index: 23,
            value: 45,
          },
          {
            index: 24,
            value: 21,
          },
          {
            index: 25,
            value: 29,
          },
          {
            index: 26,
            value: 34,
          },
          {
            index: 27,
            value: 32,
          },
          {
            index: 28,
            value: 3,
          },
          {
            index: 29,
            value: 6,
          },
          {
            index: 30,
            value: 24,
          },
          {
            index: 31,
            value: 10,
          },
          {
            index: 32,
            value: 46,
          },
          {
            index: 33,
            value: 31,
          },
          {
            index: 34,
            value: 1,
          },
          {
            index: 35,
            value: 12,
          },
          {
            index: 36,
            value: 30,
          },
          {
            index: 37,
            value: 51,
          },
          {
            index: 38,
            value: 11,
          },
          {
            index: 39,
            value: 26,
          },
          {
            index: 40,
            value: 9,
          },
          {
            index: 41,
            value: 20,
          },
          {
            index: 42,
            value: 23,
          },
          {
            index: 43,
            value: 42,
          },
          {
            index: 44,
            value: 5,
          },
          {
            index: 45,
            value: 38,
          },
          {
            index: 46,
            value: 36,
          },
          {
            index: 47,
            value: 47,
          },
          {
            index: 48,
            value: 53,
          },
          {
            index: 49,
            value: 28,
          },
          {
            index: 50,
            value: 22,
          },
          {
            index: 51,
            value: 37,
          },
        ],
      },
    },
  },
  {
    status: 200,
    body: {
      status: 200,
      msg: 'Practice round',
      data: {
        opponentName: 'lacoicd',
        opponentScore: 2390,
        secrets: [
          {
            index: 0,
            value: 28,
          },
          {
            index: 1,
            value: 30,
          },
          {
            index: 2,
            value: 9,
          },
          {
            index: 3,
            value: 48,
          },
          {
            index: 4,
            value: 39,
          },
          {
            index: 5,
            value: 50,
          },
          {
            index: 6,
            value: 7,
          },
          {
            index: 7,
            value: 1,
          },
          {
            index: 8,
            value: 53,
          },
          {
            index: 9,
            value: 52,
          },
          {
            index: 10,
            value: 12,
          },
          {
            index: 11,
            value: 45,
          },
          {
            index: 12,
            value: 27,
          },
          {
            index: 13,
            value: 36,
          },
          {
            index: 14,
            value: 29,
          },
          {
            index: 15,
            value: 49,
          },
          {
            index: 16,
            value: 23,
          },
          {
            index: 17,
            value: 35,
          },
          {
            index: 18,
            value: 33,
          },
          {
            index: 19,
            value: 11,
          },
          {
            index: 20,
            value: 13,
          },
          {
            index: 21,
            value: 0,
          },
          {
            index: 22,
            value: 14,
          },
          {
            index: 23,
            value: 17,
          },
          {
            index: 24,
            value: 51,
          },
          {
            index: 25,
            value: 47,
          },
          {
            index: 26,
            value: 3,
          },
          {
            index: 27,
            value: 44,
          },
          {
            index: 28,
            value: 20,
          },
          {
            index: 29,
            value: 10,
          },
          {
            index: 30,
            value: 8,
          },
          {
            index: 31,
            value: 16,
          },
          {
            index: 32,
            value: 37,
          },
          {
            index: 33,
            value: 40,
          },
          {
            index: 34,
            value: 32,
          },
          {
            index: 35,
            value: 43,
          },
          {
            index: 36,
            value: 18,
          },
          {
            index: 37,
            value: 34,
          },
          {
            index: 38,
            value: 21,
          },
          {
            index: 39,
            value: 6,
          },
          {
            index: 40,
            value: 46,
          },
          {
            index: 41,
            value: 4,
          },
          {
            index: 42,
            value: 24,
          },
          {
            index: 43,
            value: 5,
          },
          {
            index: 44,
            value: 22,
          },
          {
            index: 45,
            value: 31,
          },
          {
            index: 46,
            value: 25,
          },
          {
            index: 47,
            value: 26,
          },
          {
            index: 48,
            value: 38,
          },
          {
            index: 49,
            value: 42,
          },
          {
            index: 50,
            value: 2,
          },
          {
            index: 51,
            value: 41,
          },
        ],
      },
    },
  },
  {
    status: 200,
    body: {
      status: 200,
      msg: 'Practice round',
      data: {
        opponentName: 'Levis',
        opponentScore: 4320,
        secrets: [
          {
            index: 0,
            value: 2,
          },
          {
            index: 1,
            value: 42,
          },
          {
            index: 2,
            value: 32,
          },
          {
            index: 3,
            value: 27,
          },
          {
            index: 4,
            value: 16,
          },
          {
            index: 5,
            value: 5,
          },
          {
            index: 6,
            value: 26,
          },
          {
            index: 7,
            value: 40,
          },
          {
            index: 8,
            value: 0,
          },
          {
            index: 9,
            value: 21,
          },
          {
            index: 10,
            value: 8,
          },
          {
            index: 11,
            value: 14,
          },
          {
            index: 12,
            value: 6,
          },
          {
            index: 13,
            value: 52,
          },
          {
            index: 14,
            value: 46,
          },
          {
            index: 15,
            value: 22,
          },
          {
            index: 16,
            value: 30,
          },
          {
            index: 17,
            value: 38,
          },
          {
            index: 18,
            value: 34,
          },
          {
            index: 19,
            value: 3,
          },
          {
            index: 20,
            value: 9,
          },
          {
            index: 21,
            value: 15,
          },
          {
            index: 22,
            value: 36,
          },
          {
            index: 23,
            value: 20,
          },
          {
            index: 24,
            value: 48,
          },
          {
            index: 25,
            value: 4,
          },
          {
            index: 26,
            value: 19,
          },
          {
            index: 27,
            value: 33,
          },
          {
            index: 28,
            value: 41,
          },
          {
            index: 29,
            value: 39,
          },
          {
            index: 30,
            value: 37,
          },
          {
            index: 31,
            value: 12,
          },
          {
            index: 32,
            value: 49,
          },
          {
            index: 33,
            value: 35,
          },
          {
            index: 34,
            value: 45,
          },
          {
            index: 35,
            value: 44,
          },
          {
            index: 36,
            value: 53,
          },
          {
            index: 37,
            value: 10,
          },
          {
            index: 38,
            value: 28,
          },
          {
            index: 39,
            value: 43,
          },
          {
            index: 40,
            value: 47,
          },
          {
            index: 41,
            value: 18,
          },
          {
            index: 42,
            value: 24,
          },
          {
            index: 43,
            value: 31,
          },
          {
            index: 44,
            value: 23,
          },
          {
            index: 45,
            value: 50,
          },
          {
            index: 46,
            value: 11,
          },
          {
            index: 47,
            value: 7,
          },
          {
            index: 48,
            value: 51,
          },
          {
            index: 49,
            value: 13,
          },
          {
            index: 50,
            value: 1,
          },
          {
            index: 51,
            value: 29,
          },
        ],
      },
    },
  },
  {
    status: 200,
    body: {
      status: 200,
      msg: 'Practice round',
      data: {
        opponentName: 'Ziggy9044',
        opponentScore: 3020,
        secrets: [
          {
            index: 0,
            value: 12,
          },
          {
            index: 1,
            value: 42,
          },
          {
            index: 2,
            value: 29,
          },
          {
            index: 3,
            value: 33,
          },
          {
            index: 4,
            value: 34,
          },
          {
            index: 5,
            value: 3,
          },
          {
            index: 6,
            value: 32,
          },
          {
            index: 7,
            value: 37,
          },
          {
            index: 8,
            value: 28,
          },
          {
            index: 9,
            value: 14,
          },
          {
            index: 10,
            value: 53,
          },
          {
            index: 11,
            value: 50,
          },
          {
            index: 12,
            value: 13,
          },
          {
            index: 13,
            value: 4,
          },
          {
            index: 14,
            value: 36,
          },
          {
            index: 15,
            value: 31,
          },
          {
            index: 16,
            value: 45,
          },
          {
            index: 17,
            value: 9,
          },
          {
            index: 18,
            value: 30,
          },
          {
            index: 19,
            value: 11,
          },
          {
            index: 20,
            value: 22,
          },
          {
            index: 21,
            value: 19,
          },
          {
            index: 22,
            value: 38,
          },
          {
            index: 23,
            value: 43,
          },
          {
            index: 24,
            value: 48,
          },
          {
            index: 25,
            value: 40,
          },
          {
            index: 26,
            value: 46,
          },
          {
            index: 27,
            value: 0,
          },
          {
            index: 28,
            value: 20,
          },
          {
            index: 29,
            value: 49,
          },
          {
            index: 30,
            value: 16,
          },
          {
            index: 31,
            value: 2,
          },
          {
            index: 32,
            value: 10,
          },
          {
            index: 33,
            value: 41,
          },
          {
            index: 34,
            value: 26,
          },
          {
            index: 35,
            value: 1,
          },
          {
            index: 36,
            value: 23,
          },
          {
            index: 37,
            value: 24,
          },
          {
            index: 38,
            value: 6,
          },
          {
            index: 39,
            value: 51,
          },
          {
            index: 40,
            value: 15,
          },
          {
            index: 41,
            value: 27,
          },
          {
            index: 42,
            value: 39,
          },
          {
            index: 43,
            value: 18,
          },
          {
            index: 44,
            value: 44,
          },
          {
            index: 45,
            value: 52,
          },
          {
            index: 46,
            value: 25,
          },
          {
            index: 47,
            value: 8,
          },
          {
            index: 48,
            value: 21,
          },
          {
            index: 49,
            value: 5,
          },
          {
            index: 50,
            value: 17,
          },
          {
            index: 51,
            value: 7,
          },
        ],
      },
    },
  },
  {
    status: 200,
    body: {
      status: 200,
      msg: 'Practice round',
      data: {
        opponentName: 'Woo',
        opponentScore: 4020,
        secrets: [
          {
            index: 0,
            value: 37,
          },
          {
            index: 1,
            value: 17,
          },
          {
            index: 2,
            value: 39,
          },
          {
            index: 3,
            value: 0,
          },
          {
            index: 4,
            value: 30,
          },
          {
            index: 5,
            value: 23,
          },
          {
            index: 6,
            value: 52,
          },
          {
            index: 7,
            value: 18,
          },
          {
            index: 8,
            value: 16,
          },
          {
            index: 9,
            value: 4,
          },
          {
            index: 10,
            value: 44,
          },
          {
            index: 11,
            value: 22,
          },
          {
            index: 12,
            value: 21,
          },
          {
            index: 13,
            value: 43,
          },
          {
            index: 14,
            value: 27,
          },
          {
            index: 15,
            value: 36,
          },
          {
            index: 16,
            value: 3,
          },
          {
            index: 17,
            value: 41,
          },
          {
            index: 18,
            value: 38,
          },
          {
            index: 19,
            value: 9,
          },
          {
            index: 20,
            value: 10,
          },
          {
            index: 21,
            value: 2,
          },
          {
            index: 22,
            value: 26,
          },
          {
            index: 23,
            value: 1,
          },
          {
            index: 24,
            value: 7,
          },
          {
            index: 25,
            value: 29,
          },
          {
            index: 26,
            value: 33,
          },
          {
            index: 27,
            value: 49,
          },
          {
            index: 28,
            value: 5,
          },
          {
            index: 29,
            value: 8,
          },
          {
            index: 30,
            value: 28,
          },
          {
            index: 31,
            value: 45,
          },
          {
            index: 32,
            value: 51,
          },
          {
            index: 33,
            value: 34,
          },
          {
            index: 34,
            value: 13,
          },
          {
            index: 35,
            value: 12,
          },
          {
            index: 36,
            value: 32,
          },
          {
            index: 37,
            value: 40,
          },
          {
            index: 38,
            value: 11,
          },
          {
            index: 39,
            value: 20,
          },
          {
            index: 40,
            value: 42,
          },
          {
            index: 41,
            value: 47,
          },
          {
            index: 42,
            value: 14,
          },
          {
            index: 43,
            value: 25,
          },
          {
            index: 44,
            value: 50,
          },
          {
            index: 45,
            value: 53,
          },
          {
            index: 46,
            value: 48,
          },
          {
            index: 47,
            value: 46,
          },
          {
            index: 48,
            value: 31,
          },
          {
            index: 49,
            value: 6,
          },
          {
            index: 50,
            value: 24,
          },
          {
            index: 51,
            value: 15,
          },
        ],
      },
    },
  },
  {
    status: 200,
    body: {
      status: 200,
      msg: 'Practice round',
      data: {
        opponentName: 'AguM99',
        opponentScore: 4420,
        secrets: [
          {
            index: 0,
            value: 31,
          },
          {
            index: 1,
            value: 16,
          },
          {
            index: 2,
            value: 40,
          },
          {
            index: 3,
            value: 32,
          },
          {
            index: 4,
            value: 41,
          },
          {
            index: 5,
            value: 1,
          },
          {
            index: 6,
            value: 43,
          },
          {
            index: 7,
            value: 12,
          },
          {
            index: 8,
            value: 18,
          },
          {
            index: 9,
            value: 3,
          },
          {
            index: 10,
            value: 4,
          },
          {
            index: 11,
            value: 5,
          },
          {
            index: 12,
            value: 29,
          },
          {
            index: 13,
            value: 34,
          },
          {
            index: 14,
            value: 50,
          },
          {
            index: 15,
            value: 52,
          },
          {
            index: 16,
            value: 38,
          },
          {
            index: 17,
            value: 37,
          },
          {
            index: 18,
            value: 45,
          },
          {
            index: 19,
            value: 28,
          },
          {
            index: 20,
            value: 46,
          },
          {
            index: 21,
            value: 48,
          },
          {
            index: 22,
            value: 35,
          },
          {
            index: 23,
            value: 44,
          },
          {
            index: 24,
            value: 42,
          },
          {
            index: 25,
            value: 6,
          },
          {
            index: 26,
            value: 51,
          },
          {
            index: 27,
            value: 26,
          },
          {
            index: 28,
            value: 8,
          },
          {
            index: 29,
            value: 53,
          },
          {
            index: 30,
            value: 24,
          },
          {
            index: 31,
            value: 0,
          },
          {
            index: 32,
            value: 15,
          },
          {
            index: 33,
            value: 47,
          },
          {
            index: 34,
            value: 2,
          },
          {
            index: 35,
            value: 21,
          },
          {
            index: 36,
            value: 36,
          },
          {
            index: 37,
            value: 39,
          },
          {
            index: 38,
            value: 33,
          },
          {
            index: 39,
            value: 27,
          },
          {
            index: 40,
            value: 13,
          },
          {
            index: 41,
            value: 23,
          },
          {
            index: 42,
            value: 19,
          },
          {
            index: 43,
            value: 49,
          },
          {
            index: 44,
            value: 14,
          },
          {
            index: 45,
            value: 17,
          },
          {
            index: 46,
            value: 22,
          },
          {
            index: 47,
            value: 20,
          },
          {
            index: 48,
            value: 25,
          },
          {
            index: 49,
            value: 7,
          },
          {
            index: 50,
            value: 9,
          },
          {
            index: 51,
            value: 11,
          },
        ],
      },
    },
  },
  {
    status: 200,
    body: {
      status: 200,
      msg: 'Practice round',
      data: {
        opponentName: 'Pesege',
        opponentScore: 4920,
        secrets: [
          {
            index: 0,
            value: 33,
          },
          {
            index: 1,
            value: 13,
          },
          {
            index: 2,
            value: 37,
          },
          {
            index: 3,
            value: 4,
          },
          {
            index: 4,
            value: 44,
          },
          {
            index: 5,
            value: 22,
          },
          {
            index: 6,
            value: 15,
          },
          {
            index: 7,
            value: 25,
          },
          {
            index: 8,
            value: 40,
          },
          {
            index: 9,
            value: 12,
          },
          {
            index: 10,
            value: 45,
          },
          {
            index: 11,
            value: 34,
          },
          {
            index: 12,
            value: 16,
          },
          {
            index: 13,
            value: 7,
          },
          {
            index: 14,
            value: 26,
          },
          {
            index: 15,
            value: 36,
          },
          {
            index: 16,
            value: 6,
          },
          {
            index: 17,
            value: 31,
          },
          {
            index: 18,
            value: 48,
          },
          {
            index: 19,
            value: 53,
          },
          {
            index: 20,
            value: 3,
          },
          {
            index: 21,
            value: 19,
          },
          {
            index: 22,
            value: 32,
          },
          {
            index: 23,
            value: 52,
          },
          {
            index: 24,
            value: 27,
          },
          {
            index: 25,
            value: 38,
          },
          {
            index: 26,
            value: 1,
          },
          {
            index: 27,
            value: 9,
          },
          {
            index: 28,
            value: 5,
          },
          {
            index: 29,
            value: 18,
          },
          {
            index: 30,
            value: 42,
          },
          {
            index: 31,
            value: 28,
          },
          {
            index: 32,
            value: 35,
          },
          {
            index: 33,
            value: 29,
          },
          {
            index: 34,
            value: 30,
          },
          {
            index: 35,
            value: 20,
          },
          {
            index: 36,
            value: 14,
          },
          {
            index: 37,
            value: 47,
          },
          {
            index: 38,
            value: 8,
          },
          {
            index: 39,
            value: 41,
          },
          {
            index: 40,
            value: 0,
          },
          {
            index: 41,
            value: 46,
          },
          {
            index: 42,
            value: 50,
          },
          {
            index: 43,
            value: 51,
          },
          {
            index: 44,
            value: 39,
          },
          {
            index: 45,
            value: 21,
          },
          {
            index: 46,
            value: 24,
          },
          {
            index: 47,
            value: 49,
          },
          {
            index: 48,
            value: 17,
          },
          {
            index: 49,
            value: 11,
          },
          {
            index: 50,
            value: 10,
          },
          {
            index: 51,
            value: 2,
          },
        ],
      },
    },
  },
  {
    status: 200,
    body: {
      status: 200,
      msg: 'Practice round',
      data: {
        opponentName: 'WhiteGangsta',
        opponentScore: 1960,
        secrets: [
          {
            index: 0,
            value: 23,
          },
          {
            index: 1,
            value: 11,
          },
          {
            index: 2,
            value: 3,
          },
          {
            index: 3,
            value: 17,
          },
          {
            index: 4,
            value: 31,
          },
          {
            index: 5,
            value: 30,
          },
          {
            index: 6,
            value: 25,
          },
          {
            index: 7,
            value: 14,
          },
          {
            index: 8,
            value: 16,
          },
          {
            index: 9,
            value: 5,
          },
          {
            index: 10,
            value: 18,
          },
          {
            index: 11,
            value: 51,
          },
          {
            index: 12,
            value: 7,
          },
          {
            index: 13,
            value: 29,
          },
          {
            index: 14,
            value: 40,
          },
          {
            index: 15,
            value: 1,
          },
          {
            index: 16,
            value: 28,
          },
          {
            index: 17,
            value: 13,
          },
          {
            index: 18,
            value: 24,
          },
          {
            index: 19,
            value: 0,
          },
          {
            index: 20,
            value: 22,
          },
          {
            index: 21,
            value: 43,
          },
          {
            index: 22,
            value: 36,
          },
          {
            index: 23,
            value: 50,
          },
          {
            index: 24,
            value: 2,
          },
          {
            index: 25,
            value: 38,
          },
          {
            index: 26,
            value: 39,
          },
          {
            index: 27,
            value: 35,
          },
          {
            index: 28,
            value: 42,
          },
          {
            index: 29,
            value: 53,
          },
          {
            index: 30,
            value: 15,
          },
          {
            index: 31,
            value: 45,
          },
          {
            index: 32,
            value: 21,
          },
          {
            index: 33,
            value: 26,
          },
          {
            index: 34,
            value: 52,
          },
          {
            index: 35,
            value: 4,
          },
          {
            index: 36,
            value: 46,
          },
          {
            index: 37,
            value: 32,
          },
          {
            index: 38,
            value: 27,
          },
          {
            index: 39,
            value: 6,
          },
          {
            index: 40,
            value: 48,
          },
          {
            index: 41,
            value: 34,
          },
          {
            index: 42,
            value: 20,
          },
          {
            index: 43,
            value: 12,
          },
          {
            index: 44,
            value: 37,
          },
          {
            index: 45,
            value: 47,
          },
          {
            index: 46,
            value: 33,
          },
          {
            index: 47,
            value: 19,
          },
          {
            index: 48,
            value: 49,
          },
          {
            index: 49,
            value: 10,
          },
          {
            index: 50,
            value: 41,
          },
          {
            index: 51,
            value: 8,
          },
        ],
      },
    },
  },
  {
    status: 200,
    body: {
      status: 200,
      msg: 'Practice round',
      data: {
        opponentName: 'Rhea',
        opponentScore: 2120,
        secrets: [
          {
            index: 0,
            value: 15,
          },
          {
            index: 1,
            value: 42,
          },
          {
            index: 2,
            value: 17,
          },
          {
            index: 3,
            value: 29,
          },
          {
            index: 4,
            value: 26,
          },
          {
            index: 5,
            value: 25,
          },
          {
            index: 6,
            value: 47,
          },
          {
            index: 7,
            value: 7,
          },
          {
            index: 8,
            value: 11,
          },
          {
            index: 9,
            value: 40,
          },
          {
            index: 10,
            value: 53,
          },
          {
            index: 11,
            value: 13,
          },
          {
            index: 12,
            value: 6,
          },
          {
            index: 13,
            value: 43,
          },
          {
            index: 14,
            value: 41,
          },
          {
            index: 15,
            value: 19,
          },
          {
            index: 16,
            value: 35,
          },
          {
            index: 17,
            value: 4,
          },
          {
            index: 18,
            value: 52,
          },
          {
            index: 19,
            value: 38,
          },
          {
            index: 20,
            value: 8,
          },
          {
            index: 21,
            value: 33,
          },
          {
            index: 22,
            value: 37,
          },
          {
            index: 23,
            value: 21,
          },
          {
            index: 24,
            value: 14,
          },
          {
            index: 25,
            value: 45,
          },
          {
            index: 26,
            value: 23,
          },
          {
            index: 27,
            value: 0,
          },
          {
            index: 28,
            value: 27,
          },
          {
            index: 29,
            value: 12,
          },
          {
            index: 30,
            value: 3,
          },
          {
            index: 31,
            value: 49,
          },
          {
            index: 32,
            value: 24,
          },
          {
            index: 33,
            value: 34,
          },
          {
            index: 34,
            value: 39,
          },
          {
            index: 35,
            value: 5,
          },
          {
            index: 36,
            value: 28,
          },
          {
            index: 37,
            value: 16,
          },
          {
            index: 38,
            value: 32,
          },
          {
            index: 39,
            value: 36,
          },
          {
            index: 40,
            value: 48,
          },
          {
            index: 41,
            value: 46,
          },
          {
            index: 42,
            value: 9,
          },
          {
            index: 43,
            value: 51,
          },
          {
            index: 44,
            value: 44,
          },
          {
            index: 45,
            value: 31,
          },
          {
            index: 46,
            value: 50,
          },
          {
            index: 47,
            value: 30,
          },
          {
            index: 48,
            value: 1,
          },
          {
            index: 49,
            value: 2,
          },
          {
            index: 50,
            value: 22,
          },
          {
            index: 51,
            value: 18,
          },
        ],
      },
    },
  },
  {
    status: 200,
    body: {
      status: 200,
      msg: 'Practice round',
      data: {
        opponentName: 'WhiteGangsta',
        opponentScore: 4520,
        secrets: [
          {
            index: 0,
            value: 26,
          },
          {
            index: 1,
            value: 31,
          },
          {
            index: 2,
            value: 15,
          },
          {
            index: 3,
            value: 17,
          },
          {
            index: 4,
            value: 28,
          },
          {
            index: 5,
            value: 16,
          },
          {
            index: 6,
            value: 7,
          },
          {
            index: 7,
            value: 18,
          },
          {
            index: 8,
            value: 44,
          },
          {
            index: 9,
            value: 29,
          },
          {
            index: 10,
            value: 45,
          },
          {
            index: 11,
            value: 2,
          },
          {
            index: 12,
            value: 35,
          },
          {
            index: 13,
            value: 32,
          },
          {
            index: 14,
            value: 52,
          },
          {
            index: 15,
            value: 22,
          },
          {
            index: 16,
            value: 10,
          },
          {
            index: 17,
            value: 25,
          },
          {
            index: 18,
            value: 21,
          },
          {
            index: 19,
            value: 8,
          },
          {
            index: 20,
            value: 36,
          },
          {
            index: 21,
            value: 11,
          },
          {
            index: 22,
            value: 38,
          },
          {
            index: 23,
            value: 46,
          },
          {
            index: 24,
            value: 50,
          },
          {
            index: 25,
            value: 27,
          },
          {
            index: 26,
            value: 48,
          },
          {
            index: 27,
            value: 41,
          },
          {
            index: 28,
            value: 23,
          },
          {
            index: 29,
            value: 39,
          },
          {
            index: 30,
            value: 53,
          },
          {
            index: 31,
            value: 33,
          },
          {
            index: 32,
            value: 40,
          },
          {
            index: 33,
            value: 4,
          },
          {
            index: 34,
            value: 12,
          },
          {
            index: 35,
            value: 13,
          },
          {
            index: 36,
            value: 37,
          },
          {
            index: 37,
            value: 5,
          },
          {
            index: 38,
            value: 0,
          },
          {
            index: 39,
            value: 42,
          },
          {
            index: 40,
            value: 6,
          },
          {
            index: 41,
            value: 49,
          },
          {
            index: 42,
            value: 9,
          },
          {
            index: 43,
            value: 14,
          },
          {
            index: 44,
            value: 19,
          },
          {
            index: 45,
            value: 34,
          },
          {
            index: 46,
            value: 24,
          },
          {
            index: 47,
            value: 20,
          },
          {
            index: 48,
            value: 51,
          },
          {
            index: 49,
            value: 43,
          },
          {
            index: 50,
            value: 1,
          },
          {
            index: 51,
            value: 47,
          },
        ],
      },
    },
  },
  {
    status: 200,
    body: {
      status: 200,
      msg: 'Practice round',
      data: {
        opponentName: 'wowza',
        opponentScore: 2920,
        secrets: [
          {
            index: 0,
            value: 32,
          },
          {
            index: 1,
            value: 39,
          },
          {
            index: 2,
            value: 43,
          },
          {
            index: 3,
            value: 10,
          },
          {
            index: 4,
            value: 40,
          },
          {
            index: 5,
            value: 37,
          },
          {
            index: 6,
            value: 14,
          },
          {
            index: 7,
            value: 36,
          },
          {
            index: 8,
            value: 46,
          },
          {
            index: 9,
            value: 24,
          },
          {
            index: 10,
            value: 41,
          },
          {
            index: 11,
            value: 45,
          },
          {
            index: 12,
            value: 12,
          },
          {
            index: 13,
            value: 26,
          },
          {
            index: 14,
            value: 8,
          },
          {
            index: 15,
            value: 48,
          },
          {
            index: 16,
            value: 5,
          },
          {
            index: 17,
            value: 50,
          },
          {
            index: 18,
            value: 35,
          },
          {
            index: 19,
            value: 18,
          },
          {
            index: 20,
            value: 25,
          },
          {
            index: 21,
            value: 17,
          },
          {
            index: 22,
            value: 4,
          },
          {
            index: 23,
            value: 23,
          },
          {
            index: 24,
            value: 1,
          },
          {
            index: 25,
            value: 9,
          },
          {
            index: 26,
            value: 16,
          },
          {
            index: 27,
            value: 13,
          },
          {
            index: 28,
            value: 31,
          },
          {
            index: 29,
            value: 7,
          },
          {
            index: 30,
            value: 15,
          },
          {
            index: 31,
            value: 44,
          },
          {
            index: 32,
            value: 53,
          },
          {
            index: 33,
            value: 19,
          },
          {
            index: 34,
            value: 28,
          },
          {
            index: 35,
            value: 42,
          },
          {
            index: 36,
            value: 0,
          },
          {
            index: 37,
            value: 22,
          },
          {
            index: 38,
            value: 47,
          },
          {
            index: 39,
            value: 6,
          },
          {
            index: 40,
            value: 52,
          },
          {
            index: 41,
            value: 38,
          },
          {
            index: 42,
            value: 34,
          },
          {
            index: 43,
            value: 21,
          },
          {
            index: 44,
            value: 29,
          },
          {
            index: 45,
            value: 11,
          },
          {
            index: 46,
            value: 3,
          },
          {
            index: 47,
            value: 2,
          },
          {
            index: 48,
            value: 33,
          },
          {
            index: 49,
            value: 30,
          },
          {
            index: 50,
            value: 27,
          },
          {
            index: 51,
            value: 51,
          },
        ],
      },
    },
  },
  {
    status: 200,
    body: {
      status: 200,
      msg: 'Practice round',
      data: {
        opponentName: 'rafal1',
        opponentScore: 4320,
        secrets: [
          {
            index: 0,
            value: 26,
          },
          {
            index: 1,
            value: 6,
          },
          {
            index: 2,
            value: 49,
          },
          {
            index: 3,
            value: 46,
          },
          {
            index: 4,
            value: 28,
          },
          {
            index: 5,
            value: 22,
          },
          {
            index: 6,
            value: 17,
          },
          {
            index: 7,
            value: 13,
          },
          {
            index: 8,
            value: 41,
          },
          {
            index: 9,
            value: 27,
          },
          {
            index: 10,
            value: 36,
          },
          {
            index: 11,
            value: 44,
          },
          {
            index: 12,
            value: 51,
          },
          {
            index: 13,
            value: 47,
          },
          {
            index: 14,
            value: 32,
          },
          {
            index: 15,
            value: 21,
          },
          {
            index: 16,
            value: 18,
          },
          {
            index: 17,
            value: 10,
          },
          {
            index: 18,
            value: 30,
          },
          {
            index: 19,
            value: 34,
          },
          {
            index: 20,
            value: 43,
          },
          {
            index: 21,
            value: 45,
          },
          {
            index: 22,
            value: 5,
          },
          {
            index: 23,
            value: 29,
          },
          {
            index: 24,
            value: 7,
          },
          {
            index: 25,
            value: 40,
          },
          {
            index: 26,
            value: 14,
          },
          {
            index: 27,
            value: 2,
          },
          {
            index: 28,
            value: 15,
          },
          {
            index: 29,
            value: 52,
          },
          {
            index: 30,
            value: 23,
          },
          {
            index: 31,
            value: 37,
          },
          {
            index: 32,
            value: 9,
          },
          {
            index: 33,
            value: 20,
          },
          {
            index: 34,
            value: 38,
          },
          {
            index: 35,
            value: 16,
          },
          {
            index: 36,
            value: 1,
          },
          {
            index: 37,
            value: 35,
          },
          {
            index: 38,
            value: 39,
          },
          {
            index: 39,
            value: 8,
          },
          {
            index: 40,
            value: 25,
          },
          {
            index: 41,
            value: 12,
          },
          {
            index: 42,
            value: 42,
          },
          {
            index: 43,
            value: 11,
          },
          {
            index: 44,
            value: 24,
          },
          {
            index: 45,
            value: 0,
          },
          {
            index: 46,
            value: 48,
          },
          {
            index: 47,
            value: 19,
          },
          {
            index: 48,
            value: 53,
          },
          {
            index: 49,
            value: 33,
          },
          {
            index: 50,
            value: 31,
          },
          {
            index: 51,
            value: 50,
          },
        ],
      },
    },
  },
  {
    status: 200,
    body: {
      status: 200,
      msg: 'Practice round',
      data: {
        opponentName: 'cryptonator',
        opponentScore: 2380,
        secrets: [
          {
            index: 0,
            value: 0,
          },
          {
            index: 1,
            value: 42,
          },
          {
            index: 2,
            value: 44,
          },
          {
            index: 3,
            value: 29,
          },
          {
            index: 4,
            value: 26,
          },
          {
            index: 5,
            value: 9,
          },
          {
            index: 6,
            value: 50,
          },
          {
            index: 7,
            value: 40,
          },
          {
            index: 8,
            value: 16,
          },
          {
            index: 9,
            value: 14,
          },
          {
            index: 10,
            value: 1,
          },
          {
            index: 11,
            value: 18,
          },
          {
            index: 12,
            value: 33,
          },
          {
            index: 13,
            value: 3,
          },
          {
            index: 14,
            value: 45,
          },
          {
            index: 15,
            value: 46,
          },
          {
            index: 16,
            value: 43,
          },
          {
            index: 17,
            value: 17,
          },
          {
            index: 18,
            value: 11,
          },
          {
            index: 19,
            value: 21,
          },
          {
            index: 20,
            value: 15,
          },
          {
            index: 21,
            value: 23,
          },
          {
            index: 22,
            value: 20,
          },
          {
            index: 23,
            value: 8,
          },
          {
            index: 24,
            value: 48,
          },
          {
            index: 25,
            value: 19,
          },
          {
            index: 26,
            value: 7,
          },
          {
            index: 27,
            value: 31,
          },
          {
            index: 28,
            value: 13,
          },
          {
            index: 29,
            value: 36,
          },
          {
            index: 30,
            value: 5,
          },
          {
            index: 31,
            value: 22,
          },
          {
            index: 32,
            value: 53,
          },
          {
            index: 33,
            value: 39,
          },
          {
            index: 34,
            value: 52,
          },
          {
            index: 35,
            value: 30,
          },
          {
            index: 36,
            value: 2,
          },
          {
            index: 37,
            value: 24,
          },
          {
            index: 38,
            value: 28,
          },
          {
            index: 39,
            value: 34,
          },
          {
            index: 40,
            value: 25,
          },
          {
            index: 41,
            value: 51,
          },
          {
            index: 42,
            value: 4,
          },
          {
            index: 43,
            value: 37,
          },
          {
            index: 44,
            value: 49,
          },
          {
            index: 45,
            value: 35,
          },
          {
            index: 46,
            value: 6,
          },
          {
            index: 47,
            value: 10,
          },
          {
            index: 48,
            value: 41,
          },
          {
            index: 49,
            value: 32,
          },
          {
            index: 50,
            value: 27,
          },
          {
            index: 51,
            value: 12,
          },
        ],
      },
    },
  },
  {
    status: 200,
    body: {
      status: 200,
      msg: 'Practice round',
      data: {
        opponentName: 'amilcartupul',
        opponentScore: 1590,
        secrets: [
          {
            index: 0,
            value: 5,
          },
          {
            index: 1,
            value: 31,
          },
          {
            index: 2,
            value: 46,
          },
          {
            index: 3,
            value: 32,
          },
          {
            index: 4,
            value: 49,
          },
          {
            index: 5,
            value: 15,
          },
          {
            index: 6,
            value: 30,
          },
          {
            index: 7,
            value: 40,
          },
          {
            index: 8,
            value: 34,
          },
          {
            index: 9,
            value: 7,
          },
          {
            index: 10,
            value: 14,
          },
          {
            index: 11,
            value: 23,
          },
          {
            index: 12,
            value: 1,
          },
          {
            index: 13,
            value: 28,
          },
          {
            index: 14,
            value: 18,
          },
          {
            index: 15,
            value: 16,
          },
          {
            index: 16,
            value: 37,
          },
          {
            index: 17,
            value: 8,
          },
          {
            index: 18,
            value: 43,
          },
          {
            index: 19,
            value: 25,
          },
          {
            index: 20,
            value: 44,
          },
          {
            index: 21,
            value: 45,
          },
          {
            index: 22,
            value: 9,
          },
          {
            index: 23,
            value: 20,
          },
          {
            index: 24,
            value: 39,
          },
          {
            index: 25,
            value: 33,
          },
          {
            index: 26,
            value: 27,
          },
          {
            index: 27,
            value: 51,
          },
          {
            index: 28,
            value: 24,
          },
          {
            index: 29,
            value: 19,
          },
          {
            index: 30,
            value: 36,
          },
          {
            index: 31,
            value: 6,
          },
          {
            index: 32,
            value: 3,
          },
          {
            index: 33,
            value: 53,
          },
          {
            index: 34,
            value: 13,
          },
          {
            index: 35,
            value: 17,
          },
          {
            index: 36,
            value: 0,
          },
          {
            index: 37,
            value: 42,
          },
          {
            index: 38,
            value: 47,
          },
          {
            index: 39,
            value: 35,
          },
          {
            index: 40,
            value: 52,
          },
          {
            index: 41,
            value: 22,
          },
          {
            index: 42,
            value: 4,
          },
          {
            index: 43,
            value: 50,
          },
          {
            index: 44,
            value: 48,
          },
          {
            index: 45,
            value: 41,
          },
          {
            index: 46,
            value: 11,
          },
          {
            index: 47,
            value: 26,
          },
          {
            index: 48,
            value: 38,
          },
          {
            index: 49,
            value: 2,
          },
          {
            index: 50,
            value: 21,
          },
          {
            index: 51,
            value: 29,
          },
        ],
      },
    },
  },
  {
    status: 200,
    body: {
      status: 200,
      msg: 'Practice round',
      data: {
        opponentName: 'gogeta',
        opponentScore: 2820,
        secrets: [
          {
            index: 0,
            value: 53,
          },
          {
            index: 1,
            value: 47,
          },
          {
            index: 2,
            value: 41,
          },
          {
            index: 3,
            value: 17,
          },
          {
            index: 4,
            value: 21,
          },
          {
            index: 5,
            value: 36,
          },
          {
            index: 6,
            value: 2,
          },
          {
            index: 7,
            value: 11,
          },
          {
            index: 8,
            value: 24,
          },
          {
            index: 9,
            value: 20,
          },
          {
            index: 10,
            value: 29,
          },
          {
            index: 11,
            value: 19,
          },
          {
            index: 12,
            value: 8,
          },
          {
            index: 13,
            value: 22,
          },
          {
            index: 14,
            value: 23,
          },
          {
            index: 15,
            value: 0,
          },
          {
            index: 16,
            value: 14,
          },
          {
            index: 17,
            value: 1,
          },
          {
            index: 18,
            value: 26,
          },
          {
            index: 19,
            value: 25,
          },
          {
            index: 20,
            value: 37,
          },
          {
            index: 21,
            value: 3,
          },
          {
            index: 22,
            value: 18,
          },
          {
            index: 23,
            value: 16,
          },
          {
            index: 24,
            value: 38,
          },
          {
            index: 25,
            value: 35,
          },
          {
            index: 26,
            value: 9,
          },
          {
            index: 27,
            value: 33,
          },
          {
            index: 28,
            value: 48,
          },
          {
            index: 29,
            value: 51,
          },
          {
            index: 30,
            value: 32,
          },
          {
            index: 31,
            value: 30,
          },
          {
            index: 32,
            value: 43,
          },
          {
            index: 33,
            value: 12,
          },
          {
            index: 34,
            value: 45,
          },
          {
            index: 35,
            value: 31,
          },
          {
            index: 36,
            value: 7,
          },
          {
            index: 37,
            value: 13,
          },
          {
            index: 38,
            value: 10,
          },
          {
            index: 39,
            value: 5,
          },
          {
            index: 40,
            value: 49,
          },
          {
            index: 41,
            value: 52,
          },
          {
            index: 42,
            value: 4,
          },
          {
            index: 43,
            value: 46,
          },
          {
            index: 44,
            value: 50,
          },
          {
            index: 45,
            value: 15,
          },
          {
            index: 46,
            value: 27,
          },
          {
            index: 47,
            value: 39,
          },
          {
            index: 48,
            value: 28,
          },
          {
            index: 49,
            value: 40,
          },
          {
            index: 50,
            value: 44,
          },
          {
            index: 51,
            value: 34,
          },
        ],
      },
    },
  },
  {
    status: 200,
    body: {
      status: 200,
      msg: 'Practice round',
      data: {
        opponentName: 'gogeta',
        opponentScore: 2690,
        secrets: [
          {
            index: 0,
            value: 53,
          },
          {
            index: 1,
            value: 44,
          },
          {
            index: 2,
            value: 28,
          },
          {
            index: 3,
            value: 37,
          },
          {
            index: 4,
            value: 34,
          },
          {
            index: 5,
            value: 40,
          },
          {
            index: 6,
            value: 2,
          },
          {
            index: 7,
            value: 19,
          },
          {
            index: 8,
            value: 21,
          },
          {
            index: 9,
            value: 39,
          },
          {
            index: 10,
            value: 25,
          },
          {
            index: 11,
            value: 41,
          },
          {
            index: 12,
            value: 24,
          },
          {
            index: 13,
            value: 42,
          },
          {
            index: 14,
            value: 38,
          },
          {
            index: 15,
            value: 16,
          },
          {
            index: 16,
            value: 11,
          },
          {
            index: 17,
            value: 35,
          },
          {
            index: 18,
            value: 31,
          },
          {
            index: 19,
            value: 8,
          },
          {
            index: 20,
            value: 26,
          },
          {
            index: 21,
            value: 33,
          },
          {
            index: 22,
            value: 1,
          },
          {
            index: 23,
            value: 20,
          },
          {
            index: 24,
            value: 45,
          },
          {
            index: 25,
            value: 47,
          },
          {
            index: 26,
            value: 0,
          },
          {
            index: 27,
            value: 7,
          },
          {
            index: 28,
            value: 50,
          },
          {
            index: 29,
            value: 23,
          },
          {
            index: 30,
            value: 15,
          },
          {
            index: 31,
            value: 10,
          },
          {
            index: 32,
            value: 12,
          },
          {
            index: 33,
            value: 51,
          },
          {
            index: 34,
            value: 3,
          },
          {
            index: 35,
            value: 6,
          },
          {
            index: 36,
            value: 52,
          },
          {
            index: 37,
            value: 46,
          },
          {
            index: 38,
            value: 29,
          },
          {
            index: 39,
            value: 49,
          },
          {
            index: 40,
            value: 9,
          },
          {
            index: 41,
            value: 22,
          },
          {
            index: 42,
            value: 43,
          },
          {
            index: 43,
            value: 17,
          },
          {
            index: 44,
            value: 27,
          },
          {
            index: 45,
            value: 13,
          },
          {
            index: 46,
            value: 4,
          },
          {
            index: 47,
            value: 5,
          },
          {
            index: 48,
            value: 32,
          },
          {
            index: 49,
            value: 30,
          },
          {
            index: 50,
            value: 36,
          },
          {
            index: 51,
            value: 14,
          },
        ],
      },
    },
  },
  {
    status: 200,
    body: {
      status: 200,
      msg: 'Practice round',
      data: {
        opponentName: 'cryptonator',
        opponentScore: 1240,
        secrets: [
          {
            index: 0,
            value: 45,
          },
          {
            index: 1,
            value: 47,
          },
          {
            index: 2,
            value: 43,
          },
          {
            index: 3,
            value: 20,
          },
          {
            index: 4,
            value: 25,
          },
          {
            index: 5,
            value: 34,
          },
          {
            index: 6,
            value: 11,
          },
          {
            index: 7,
            value: 12,
          },
          {
            index: 8,
            value: 38,
          },
          {
            index: 9,
            value: 15,
          },
          {
            index: 10,
            value: 24,
          },
          {
            index: 11,
            value: 41,
          },
          {
            index: 12,
            value: 37,
          },
          {
            index: 13,
            value: 4,
          },
          {
            index: 14,
            value: 26,
          },
          {
            index: 15,
            value: 21,
          },
          {
            index: 16,
            value: 6,
          },
          {
            index: 17,
            value: 16,
          },
          {
            index: 18,
            value: 2,
          },
          {
            index: 19,
            value: 35,
          },
          {
            index: 20,
            value: 5,
          },
          {
            index: 21,
            value: 17,
          },
          {
            index: 22,
            value: 28,
          },
          {
            index: 23,
            value: 14,
          },
          {
            index: 24,
            value: 8,
          },
          {
            index: 25,
            value: 19,
          },
          {
            index: 26,
            value: 32,
          },
          {
            index: 27,
            value: 33,
          },
          {
            index: 28,
            value: 0,
          },
          {
            index: 29,
            value: 22,
          },
          {
            index: 30,
            value: 53,
          },
          {
            index: 31,
            value: 39,
          },
          {
            index: 32,
            value: 50,
          },
          {
            index: 33,
            value: 3,
          },
          {
            index: 34,
            value: 13,
          },
          {
            index: 35,
            value: 49,
          },
          {
            index: 36,
            value: 31,
          },
          {
            index: 37,
            value: 1,
          },
          {
            index: 38,
            value: 36,
          },
          {
            index: 39,
            value: 7,
          },
          {
            index: 40,
            value: 10,
          },
          {
            index: 41,
            value: 46,
          },
          {
            index: 42,
            value: 18,
          },
          {
            index: 43,
            value: 42,
          },
          {
            index: 44,
            value: 27,
          },
          {
            index: 45,
            value: 29,
          },
          {
            index: 46,
            value: 40,
          },
          {
            index: 47,
            value: 51,
          },
          {
            index: 48,
            value: 9,
          },
          {
            index: 49,
            value: 52,
          },
          {
            index: 50,
            value: 23,
          },
          {
            index: 51,
            value: 44,
          },
        ],
      },
    },
  },
  {
    status: 200,
    body: {
      status: 200,
      msg: 'Practice round',
      data: {
        opponentName: 'Levis',
        opponentScore: 5220,
        secrets: [
          {
            index: 0,
            value: 47,
          },
          {
            index: 1,
            value: 3,
          },
          {
            index: 2,
            value: 18,
          },
          {
            index: 3,
            value: 49,
          },
          {
            index: 4,
            value: 7,
          },
          {
            index: 5,
            value: 2,
          },
          {
            index: 6,
            value: 11,
          },
          {
            index: 7,
            value: 32,
          },
          {
            index: 8,
            value: 13,
          },
          {
            index: 9,
            value: 31,
          },
          {
            index: 10,
            value: 34,
          },
          {
            index: 11,
            value: 12,
          },
          {
            index: 12,
            value: 16,
          },
          {
            index: 13,
            value: 17,
          },
          {
            index: 14,
            value: 40,
          },
          {
            index: 15,
            value: 45,
          },
          {
            index: 16,
            value: 4,
          },
          {
            index: 17,
            value: 27,
          },
          {
            index: 18,
            value: 38,
          },
          {
            index: 19,
            value: 37,
          },
          {
            index: 20,
            value: 46,
          },
          {
            index: 21,
            value: 14,
          },
          {
            index: 22,
            value: 39,
          },
          {
            index: 23,
            value: 42,
          },
          {
            index: 24,
            value: 30,
          },
          {
            index: 25,
            value: 5,
          },
          {
            index: 26,
            value: 21,
          },
          {
            index: 27,
            value: 9,
          },
          {
            index: 28,
            value: 6,
          },
          {
            index: 29,
            value: 29,
          },
          {
            index: 30,
            value: 15,
          },
          {
            index: 31,
            value: 33,
          },
          {
            index: 32,
            value: 53,
          },
          {
            index: 33,
            value: 26,
          },
          {
            index: 34,
            value: 36,
          },
          {
            index: 35,
            value: 0,
          },
          {
            index: 36,
            value: 22,
          },
          {
            index: 37,
            value: 43,
          },
          {
            index: 38,
            value: 52,
          },
          {
            index: 39,
            value: 50,
          },
          {
            index: 40,
            value: 24,
          },
          {
            index: 41,
            value: 8,
          },
          {
            index: 42,
            value: 35,
          },
          {
            index: 43,
            value: 51,
          },
          {
            index: 44,
            value: 41,
          },
          {
            index: 45,
            value: 1,
          },
          {
            index: 46,
            value: 23,
          },
          {
            index: 47,
            value: 20,
          },
          {
            index: 48,
            value: 48,
          },
          {
            index: 49,
            value: 10,
          },
          {
            index: 50,
            value: 19,
          },
          {
            index: 51,
            value: 28,
          },
        ],
      },
    },
  },
  {
    status: 200,
    body: {
      status: 200,
      msg: 'Practice round',
      data: {
        opponentName: 'Woo',
        opponentScore: 3920,
        secrets: [
          {
            index: 0,
            value: 37,
          },
          {
            index: 1,
            value: 18,
          },
          {
            index: 2,
            value: 31,
          },
          {
            index: 3,
            value: 40,
          },
          {
            index: 4,
            value: 4,
          },
          {
            index: 5,
            value: 51,
          },
          {
            index: 6,
            value: 43,
          },
          {
            index: 7,
            value: 36,
          },
          {
            index: 8,
            value: 39,
          },
          {
            index: 9,
            value: 42,
          },
          {
            index: 10,
            value: 23,
          },
          {
            index: 11,
            value: 8,
          },
          {
            index: 12,
            value: 5,
          },
          {
            index: 13,
            value: 21,
          },
          {
            index: 14,
            value: 17,
          },
          {
            index: 15,
            value: 52,
          },
          {
            index: 16,
            value: 19,
          },
          {
            index: 17,
            value: 10,
          },
          {
            index: 18,
            value: 45,
          },
          {
            index: 19,
            value: 28,
          },
          {
            index: 20,
            value: 16,
          },
          {
            index: 21,
            value: 27,
          },
          {
            index: 22,
            value: 44,
          },
          {
            index: 23,
            value: 38,
          },
          {
            index: 24,
            value: 13,
          },
          {
            index: 25,
            value: 47,
          },
          {
            index: 26,
            value: 20,
          },
          {
            index: 27,
            value: 26,
          },
          {
            index: 28,
            value: 3,
          },
          {
            index: 29,
            value: 34,
          },
          {
            index: 30,
            value: 2,
          },
          {
            index: 31,
            value: 35,
          },
          {
            index: 32,
            value: 41,
          },
          {
            index: 33,
            value: 29,
          },
          {
            index: 34,
            value: 46,
          },
          {
            index: 35,
            value: 1,
          },
          {
            index: 36,
            value: 33,
          },
          {
            index: 37,
            value: 25,
          },
          {
            index: 38,
            value: 14,
          },
          {
            index: 39,
            value: 7,
          },
          {
            index: 40,
            value: 11,
          },
          {
            index: 41,
            value: 6,
          },
          {
            index: 42,
            value: 48,
          },
          {
            index: 43,
            value: 0,
          },
          {
            index: 44,
            value: 9,
          },
          {
            index: 45,
            value: 30,
          },
          {
            index: 46,
            value: 53,
          },
          {
            index: 47,
            value: 22,
          },
          {
            index: 48,
            value: 24,
          },
          {
            index: 49,
            value: 32,
          },
          {
            index: 50,
            value: 50,
          },
          {
            index: 51,
            value: 12,
          },
        ],
      },
    },
  },
  {
    status: 200,
    body: {
      status: 200,
      msg: 'Practice round',
      data: {
        opponentName: 'manuu',
        opponentScore: 440,
        secrets: [
          {
            index: 0,
            value: 8,
          },
          {
            index: 1,
            value: 44,
          },
          {
            index: 2,
            value: 26,
          },
          {
            index: 3,
            value: 21,
          },
          {
            index: 4,
            value: 45,
          },
          {
            index: 5,
            value: 40,
          },
          {
            index: 6,
            value: 4,
          },
          {
            index: 7,
            value: 35,
          },
          {
            index: 8,
            value: 41,
          },
          {
            index: 9,
            value: 20,
          },
          {
            index: 10,
            value: 51,
          },
          {
            index: 11,
            value: 29,
          },
          {
            index: 12,
            value: 49,
          },
          {
            index: 13,
            value: 38,
          },
          {
            index: 14,
            value: 3,
          },
          {
            index: 15,
            value: 9,
          },
          {
            index: 16,
            value: 32,
          },
          {
            index: 17,
            value: 31,
          },
          {
            index: 18,
            value: 25,
          },
          {
            index: 19,
            value: 17,
          },
          {
            index: 20,
            value: 23,
          },
          {
            index: 21,
            value: 10,
          },
          {
            index: 22,
            value: 50,
          },
          {
            index: 23,
            value: 7,
          },
          {
            index: 24,
            value: 12,
          },
          {
            index: 25,
            value: 6,
          },
          {
            index: 26,
            value: 13,
          },
          {
            index: 27,
            value: 37,
          },
          {
            index: 28,
            value: 1,
          },
          {
            index: 29,
            value: 42,
          },
          {
            index: 30,
            value: 0,
          },
          {
            index: 31,
            value: 28,
          },
          {
            index: 32,
            value: 15,
          },
          {
            index: 33,
            value: 2,
          },
          {
            index: 34,
            value: 30,
          },
          {
            index: 35,
            value: 47,
          },
          {
            index: 36,
            value: 16,
          },
          {
            index: 37,
            value: 18,
          },
          {
            index: 38,
            value: 19,
          },
          {
            index: 39,
            value: 33,
          },
          {
            index: 40,
            value: 22,
          },
          {
            index: 41,
            value: 39,
          },
          {
            index: 42,
            value: 52,
          },
          {
            index: 43,
            value: 46,
          },
          {
            index: 44,
            value: 27,
          },
          {
            index: 45,
            value: 48,
          },
          {
            index: 46,
            value: 5,
          },
          {
            index: 47,
            value: 36,
          },
          {
            index: 48,
            value: 14,
          },
          {
            index: 49,
            value: 11,
          },
          {
            index: 50,
            value: 53,
          },
          {
            index: 51,
            value: 24,
          },
        ],
      },
    },
  },
  {
    status: 200,
    body: {
      status: 200,
      msg: 'Practice round',
      data: {
        opponentName: 'Ziggy9044',
        opponentScore: 2540,
        secrets: [
          {
            index: 0,
            value: 40,
          },
          {
            index: 1,
            value: 7,
          },
          {
            index: 2,
            value: 1,
          },
          {
            index: 3,
            value: 33,
          },
          {
            index: 4,
            value: 12,
          },
          {
            index: 5,
            value: 11,
          },
          {
            index: 6,
            value: 38,
          },
          {
            index: 7,
            value: 42,
          },
          {
            index: 8,
            value: 24,
          },
          {
            index: 9,
            value: 49,
          },
          {
            index: 10,
            value: 0,
          },
          {
            index: 11,
            value: 10,
          },
          {
            index: 12,
            value: 30,
          },
          {
            index: 13,
            value: 9,
          },
          {
            index: 14,
            value: 3,
          },
          {
            index: 15,
            value: 16,
          },
          {
            index: 16,
            value: 23,
          },
          {
            index: 17,
            value: 43,
          },
          {
            index: 18,
            value: 28,
          },
          {
            index: 19,
            value: 29,
          },
          {
            index: 20,
            value: 39,
          },
          {
            index: 21,
            value: 34,
          },
          {
            index: 22,
            value: 2,
          },
          {
            index: 23,
            value: 17,
          },
          {
            index: 24,
            value: 48,
          },
          {
            index: 25,
            value: 20,
          },
          {
            index: 26,
            value: 45,
          },
          {
            index: 27,
            value: 4,
          },
          {
            index: 28,
            value: 26,
          },
          {
            index: 29,
            value: 53,
          },
          {
            index: 30,
            value: 18,
          },
          {
            index: 31,
            value: 44,
          },
          {
            index: 32,
            value: 52,
          },
          {
            index: 33,
            value: 13,
          },
          {
            index: 34,
            value: 8,
          },
          {
            index: 35,
            value: 25,
          },
          {
            index: 36,
            value: 32,
          },
          {
            index: 37,
            value: 41,
          },
          {
            index: 38,
            value: 27,
          },
          {
            index: 39,
            value: 36,
          },
          {
            index: 40,
            value: 35,
          },
          {
            index: 41,
            value: 15,
          },
          {
            index: 42,
            value: 51,
          },
          {
            index: 43,
            value: 50,
          },
          {
            index: 44,
            value: 21,
          },
          {
            index: 45,
            value: 5,
          },
          {
            index: 46,
            value: 47,
          },
          {
            index: 47,
            value: 37,
          },
          {
            index: 48,
            value: 31,
          },
          {
            index: 49,
            value: 6,
          },
          {
            index: 50,
            value: 19,
          },
          {
            index: 51,
            value: 14,
          },
        ],
      },
    },
  },
  {
    status: 200,
    body: {
      status: 200,
      msg: 'Practice round',
      data: {
        opponentName: 'pewoili',
        opponentScore: 2540,
        secrets: [
          {
            index: 0,
            value: 29,
          },
          {
            index: 1,
            value: 4,
          },
          {
            index: 2,
            value: 16,
          },
          {
            index: 3,
            value: 43,
          },
          {
            index: 4,
            value: 18,
          },
          {
            index: 5,
            value: 37,
          },
          {
            index: 6,
            value: 24,
          },
          {
            index: 7,
            value: 40,
          },
          {
            index: 8,
            value: 53,
          },
          {
            index: 9,
            value: 6,
          },
          {
            index: 10,
            value: 14,
          },
          {
            index: 11,
            value: 48,
          },
          {
            index: 12,
            value: 51,
          },
          {
            index: 13,
            value: 44,
          },
          {
            index: 14,
            value: 0,
          },
          {
            index: 15,
            value: 3,
          },
          {
            index: 16,
            value: 15,
          },
          {
            index: 17,
            value: 1,
          },
          {
            index: 18,
            value: 32,
          },
          {
            index: 19,
            value: 49,
          },
          {
            index: 20,
            value: 27,
          },
          {
            index: 21,
            value: 17,
          },
          {
            index: 22,
            value: 34,
          },
          {
            index: 23,
            value: 33,
          },
          {
            index: 24,
            value: 41,
          },
          {
            index: 25,
            value: 35,
          },
          {
            index: 26,
            value: 52,
          },
          {
            index: 27,
            value: 25,
          },
          {
            index: 28,
            value: 19,
          },
          {
            index: 29,
            value: 13,
          },
          {
            index: 30,
            value: 38,
          },
          {
            index: 31,
            value: 36,
          },
          {
            index: 32,
            value: 26,
          },
          {
            index: 33,
            value: 20,
          },
          {
            index: 34,
            value: 5,
          },
          {
            index: 35,
            value: 22,
          },
          {
            index: 36,
            value: 42,
          },
          {
            index: 37,
            value: 39,
          },
          {
            index: 38,
            value: 28,
          },
          {
            index: 39,
            value: 2,
          },
          {
            index: 40,
            value: 7,
          },
          {
            index: 41,
            value: 8,
          },
          {
            index: 42,
            value: 21,
          },
          {
            index: 43,
            value: 45,
          },
          {
            index: 44,
            value: 9,
          },
          {
            index: 45,
            value: 10,
          },
          {
            index: 46,
            value: 30,
          },
          {
            index: 47,
            value: 47,
          },
          {
            index: 48,
            value: 12,
          },
          {
            index: 49,
            value: 46,
          },
          {
            index: 50,
            value: 23,
          },
          {
            index: 51,
            value: 11,
          },
        ],
      },
    },
  },
  {
    status: 200,
    body: {
      status: 200,
      msg: 'Practice round',
      data: {
        opponentName: 'cominforyourmoney',
        opponentScore: 3120,
        secrets: [
          {
            index: 0,
            value: 40,
          },
          {
            index: 1,
            value: 12,
          },
          {
            index: 2,
            value: 19,
          },
          {
            index: 3,
            value: 30,
          },
          {
            index: 4,
            value: 39,
          },
          {
            index: 5,
            value: 25,
          },
          {
            index: 6,
            value: 6,
          },
          {
            index: 7,
            value: 15,
          },
          {
            index: 8,
            value: 49,
          },
          {
            index: 9,
            value: 9,
          },
          {
            index: 10,
            value: 7,
          },
          {
            index: 11,
            value: 17,
          },
          {
            index: 12,
            value: 46,
          },
          {
            index: 13,
            value: 20,
          },
          {
            index: 14,
            value: 52,
          },
          {
            index: 15,
            value: 53,
          },
          {
            index: 16,
            value: 22,
          },
          {
            index: 17,
            value: 24,
          },
          {
            index: 18,
            value: 3,
          },
          {
            index: 19,
            value: 47,
          },
          {
            index: 20,
            value: 33,
          },
          {
            index: 21,
            value: 18,
          },
          {
            index: 22,
            value: 43,
          },
          {
            index: 23,
            value: 51,
          },
          {
            index: 24,
            value: 31,
          },
          {
            index: 25,
            value: 0,
          },
          {
            index: 26,
            value: 13,
          },
          {
            index: 27,
            value: 50,
          },
          {
            index: 28,
            value: 35,
          },
          {
            index: 29,
            value: 23,
          },
          {
            index: 30,
            value: 41,
          },
          {
            index: 31,
            value: 28,
          },
          {
            index: 32,
            value: 8,
          },
          {
            index: 33,
            value: 48,
          },
          {
            index: 34,
            value: 42,
          },
          {
            index: 35,
            value: 27,
          },
          {
            index: 36,
            value: 32,
          },
          {
            index: 37,
            value: 16,
          },
          {
            index: 38,
            value: 29,
          },
          {
            index: 39,
            value: 38,
          },
          {
            index: 40,
            value: 45,
          },
          {
            index: 41,
            value: 34,
          },
          {
            index: 42,
            value: 37,
          },
          {
            index: 43,
            value: 26,
          },
          {
            index: 44,
            value: 36,
          },
          {
            index: 45,
            value: 10,
          },
          {
            index: 46,
            value: 4,
          },
          {
            index: 47,
            value: 11,
          },
          {
            index: 48,
            value: 14,
          },
          {
            index: 49,
            value: 21,
          },
          {
            index: 50,
            value: 44,
          },
          {
            index: 51,
            value: 5,
          },
        ],
      },
    },
  },
  {
    status: 200,
    body: {
      status: 200,
      msg: 'Practice round',
      data: {
        opponentName: 'Pesege',
        opponentScore: 2420,
        secrets: [
          {
            index: 0,
            value: 45,
          },
          {
            index: 1,
            value: 36,
          },
          {
            index: 2,
            value: 7,
          },
          {
            index: 3,
            value: 44,
          },
          {
            index: 4,
            value: 30,
          },
          {
            index: 5,
            value: 42,
          },
          {
            index: 6,
            value: 32,
          },
          {
            index: 7,
            value: 10,
          },
          {
            index: 8,
            value: 2,
          },
          {
            index: 9,
            value: 49,
          },
          {
            index: 10,
            value: 38,
          },
          {
            index: 11,
            value: 11,
          },
          {
            index: 12,
            value: 20,
          },
          {
            index: 13,
            value: 47,
          },
          {
            index: 14,
            value: 39,
          },
          {
            index: 15,
            value: 21,
          },
          {
            index: 16,
            value: 50,
          },
          {
            index: 17,
            value: 37,
          },
          {
            index: 18,
            value: 3,
          },
          {
            index: 19,
            value: 5,
          },
          {
            index: 20,
            value: 24,
          },
          {
            index: 21,
            value: 0,
          },
          {
            index: 22,
            value: 6,
          },
          {
            index: 23,
            value: 15,
          },
          {
            index: 24,
            value: 53,
          },
          {
            index: 25,
            value: 22,
          },
          {
            index: 26,
            value: 29,
          },
          {
            index: 27,
            value: 34,
          },
          {
            index: 28,
            value: 16,
          },
          {
            index: 29,
            value: 41,
          },
          {
            index: 30,
            value: 33,
          },
          {
            index: 31,
            value: 9,
          },
          {
            index: 32,
            value: 28,
          },
          {
            index: 33,
            value: 51,
          },
          {
            index: 34,
            value: 12,
          },
          {
            index: 35,
            value: 52,
          },
          {
            index: 36,
            value: 26,
          },
          {
            index: 37,
            value: 18,
          },
          {
            index: 38,
            value: 43,
          },
          {
            index: 39,
            value: 46,
          },
          {
            index: 40,
            value: 1,
          },
          {
            index: 41,
            value: 19,
          },
          {
            index: 42,
            value: 14,
          },
          {
            index: 43,
            value: 8,
          },
          {
            index: 44,
            value: 23,
          },
          {
            index: 45,
            value: 4,
          },
          {
            index: 46,
            value: 27,
          },
          {
            index: 47,
            value: 13,
          },
          {
            index: 48,
            value: 48,
          },
          {
            index: 49,
            value: 31,
          },
          {
            index: 50,
            value: 35,
          },
          {
            index: 51,
            value: 40,
          },
        ],
      },
    },
  },
  {
    status: 200,
    body: {
      status: 200,
      msg: 'Practice round',
      data: {
        opponentName: 'Louie II',
        opponentScore: 2540,
        secrets: [
          {
            index: 0,
            value: 34,
          },
          {
            index: 1,
            value: 10,
          },
          {
            index: 2,
            value: 35,
          },
          {
            index: 3,
            value: 20,
          },
          {
            index: 4,
            value: 25,
          },
          {
            index: 5,
            value: 6,
          },
          {
            index: 6,
            value: 17,
          },
          {
            index: 7,
            value: 8,
          },
          {
            index: 8,
            value: 48,
          },
          {
            index: 9,
            value: 5,
          },
          {
            index: 10,
            value: 21,
          },
          {
            index: 11,
            value: 14,
          },
          {
            index: 12,
            value: 23,
          },
          {
            index: 13,
            value: 29,
          },
          {
            index: 14,
            value: 53,
          },
          {
            index: 15,
            value: 50,
          },
          {
            index: 16,
            value: 37,
          },
          {
            index: 17,
            value: 27,
          },
          {
            index: 18,
            value: 49,
          },
          {
            index: 19,
            value: 11,
          },
          {
            index: 20,
            value: 41,
          },
          {
            index: 21,
            value: 13,
          },
          {
            index: 22,
            value: 16,
          },
          {
            index: 23,
            value: 39,
          },
          {
            index: 24,
            value: 38,
          },
          {
            index: 25,
            value: 3,
          },
          {
            index: 26,
            value: 42,
          },
          {
            index: 27,
            value: 47,
          },
          {
            index: 28,
            value: 4,
          },
          {
            index: 29,
            value: 1,
          },
          {
            index: 30,
            value: 32,
          },
          {
            index: 31,
            value: 19,
          },
          {
            index: 32,
            value: 26,
          },
          {
            index: 33,
            value: 28,
          },
          {
            index: 34,
            value: 18,
          },
          {
            index: 35,
            value: 24,
          },
          {
            index: 36,
            value: 45,
          },
          {
            index: 37,
            value: 40,
          },
          {
            index: 38,
            value: 52,
          },
          {
            index: 39,
            value: 0,
          },
          {
            index: 40,
            value: 43,
          },
          {
            index: 41,
            value: 2,
          },
          {
            index: 42,
            value: 46,
          },
          {
            index: 43,
            value: 9,
          },
          {
            index: 44,
            value: 12,
          },
          {
            index: 45,
            value: 44,
          },
          {
            index: 46,
            value: 33,
          },
          {
            index: 47,
            value: 15,
          },
          {
            index: 48,
            value: 36,
          },
          {
            index: 49,
            value: 51,
          },
          {
            index: 50,
            value: 31,
          },
          {
            index: 51,
            value: 7,
          },
        ],
      },
    },
  },
  {
    status: 200,
    body: {
      status: 200,
      msg: 'Practice round',
      data: {
        opponentName: 'loidaproen',
        opponentScore: 3690,
        secrets: [
          {
            index: 0,
            value: 46,
          },
          {
            index: 1,
            value: 19,
          },
          {
            index: 2,
            value: 36,
          },
          {
            index: 3,
            value: 31,
          },
          {
            index: 4,
            value: 3,
          },
          {
            index: 5,
            value: 48,
          },
          {
            index: 6,
            value: 34,
          },
          {
            index: 7,
            value: 49,
          },
          {
            index: 8,
            value: 15,
          },
          {
            index: 9,
            value: 21,
          },
          {
            index: 10,
            value: 14,
          },
          {
            index: 11,
            value: 51,
          },
          {
            index: 12,
            value: 24,
          },
          {
            index: 13,
            value: 10,
          },
          {
            index: 14,
            value: 39,
          },
          {
            index: 15,
            value: 20,
          },
          {
            index: 16,
            value: 41,
          },
          {
            index: 17,
            value: 12,
          },
          {
            index: 18,
            value: 18,
          },
          {
            index: 19,
            value: 37,
          },
          {
            index: 20,
            value: 28,
          },
          {
            index: 21,
            value: 27,
          },
          {
            index: 22,
            value: 29,
          },
          {
            index: 23,
            value: 40,
          },
          {
            index: 24,
            value: 13,
          },
          {
            index: 25,
            value: 22,
          },
          {
            index: 26,
            value: 1,
          },
          {
            index: 27,
            value: 47,
          },
          {
            index: 28,
            value: 53,
          },
          {
            index: 29,
            value: 7,
          },
          {
            index: 30,
            value: 5,
          },
          {
            index: 31,
            value: 38,
          },
          {
            index: 32,
            value: 42,
          },
          {
            index: 33,
            value: 17,
          },
          {
            index: 34,
            value: 23,
          },
          {
            index: 35,
            value: 52,
          },
          {
            index: 36,
            value: 6,
          },
          {
            index: 37,
            value: 25,
          },
          {
            index: 38,
            value: 33,
          },
          {
            index: 39,
            value: 4,
          },
          {
            index: 40,
            value: 2,
          },
          {
            index: 41,
            value: 0,
          },
          {
            index: 42,
            value: 16,
          },
          {
            index: 43,
            value: 32,
          },
          {
            index: 44,
            value: 30,
          },
          {
            index: 45,
            value: 26,
          },
          {
            index: 46,
            value: 44,
          },
          {
            index: 47,
            value: 9,
          },
          {
            index: 48,
            value: 8,
          },
          {
            index: 49,
            value: 45,
          },
          {
            index: 50,
            value: 50,
          },
          {
            index: 51,
            value: 35,
          },
        ],
      },
    },
  },
  {
    status: 200,
    body: {
      status: 200,
      msg: 'Practice round',
      data: {
        opponentName: 'tigrio',
        opponentScore: 1490,
        secrets: [
          {
            index: 0,
            value: 7,
          },
          {
            index: 1,
            value: 29,
          },
          {
            index: 2,
            value: 3,
          },
          {
            index: 3,
            value: 42,
          },
          {
            index: 4,
            value: 33,
          },
          {
            index: 5,
            value: 20,
          },
          {
            index: 6,
            value: 2,
          },
          {
            index: 7,
            value: 17,
          },
          {
            index: 8,
            value: 53,
          },
          {
            index: 9,
            value: 35,
          },
          {
            index: 10,
            value: 41,
          },
          {
            index: 11,
            value: 10,
          },
          {
            index: 12,
            value: 34,
          },
          {
            index: 13,
            value: 48,
          },
          {
            index: 14,
            value: 31,
          },
          {
            index: 15,
            value: 44,
          },
          {
            index: 16,
            value: 6,
          },
          {
            index: 17,
            value: 38,
          },
          {
            index: 18,
            value: 30,
          },
          {
            index: 19,
            value: 15,
          },
          {
            index: 20,
            value: 18,
          },
          {
            index: 21,
            value: 5,
          },
          {
            index: 22,
            value: 49,
          },
          {
            index: 23,
            value: 1,
          },
          {
            index: 24,
            value: 32,
          },
          {
            index: 25,
            value: 0,
          },
          {
            index: 26,
            value: 40,
          },
          {
            index: 27,
            value: 51,
          },
          {
            index: 28,
            value: 21,
          },
          {
            index: 29,
            value: 22,
          },
          {
            index: 30,
            value: 12,
          },
          {
            index: 31,
            value: 11,
          },
          {
            index: 32,
            value: 47,
          },
          {
            index: 33,
            value: 52,
          },
          {
            index: 34,
            value: 4,
          },
          {
            index: 35,
            value: 28,
          },
          {
            index: 36,
            value: 14,
          },
          {
            index: 37,
            value: 8,
          },
          {
            index: 38,
            value: 39,
          },
          {
            index: 39,
            value: 46,
          },
          {
            index: 40,
            value: 27,
          },
          {
            index: 41,
            value: 37,
          },
          {
            index: 42,
            value: 26,
          },
          {
            index: 43,
            value: 13,
          },
          {
            index: 44,
            value: 19,
          },
          {
            index: 45,
            value: 43,
          },
          {
            index: 46,
            value: 45,
          },
          {
            index: 47,
            value: 23,
          },
          {
            index: 48,
            value: 36,
          },
          {
            index: 49,
            value: 24,
          },
          {
            index: 50,
            value: 9,
          },
          {
            index: 51,
            value: 16,
          },
        ],
      },
    },
  },
  {
    status: 200,
    body: {
      status: 200,
      msg: 'Practice round',
      data: {
        opponentName: 'Shirinilam',
        opponentScore: 520,
        secrets: [
          {
            index: 0,
            value: 9,
          },
          {
            index: 1,
            value: 20,
          },
          {
            index: 2,
            value: 44,
          },
          {
            index: 3,
            value: 42,
          },
          {
            index: 4,
            value: 25,
          },
          {
            index: 5,
            value: 36,
          },
          {
            index: 6,
            value: 23,
          },
          {
            index: 7,
            value: 2,
          },
          {
            index: 8,
            value: 46,
          },
          {
            index: 9,
            value: 1,
          },
          {
            index: 10,
            value: 27,
          },
          {
            index: 11,
            value: 5,
          },
          {
            index: 12,
            value: 10,
          },
          {
            index: 13,
            value: 11,
          },
          {
            index: 14,
            value: 33,
          },
          {
            index: 15,
            value: 34,
          },
          {
            index: 16,
            value: 4,
          },
          {
            index: 17,
            value: 45,
          },
          {
            index: 18,
            value: 7,
          },
          {
            index: 19,
            value: 16,
          },
          {
            index: 20,
            value: 51,
          },
          {
            index: 21,
            value: 52,
          },
          {
            index: 22,
            value: 24,
          },
          {
            index: 23,
            value: 26,
          },
          {
            index: 24,
            value: 47,
          },
          {
            index: 25,
            value: 37,
          },
          {
            index: 26,
            value: 32,
          },
          {
            index: 27,
            value: 21,
          },
          {
            index: 28,
            value: 48,
          },
          {
            index: 29,
            value: 22,
          },
          {
            index: 30,
            value: 29,
          },
          {
            index: 31,
            value: 41,
          },
          {
            index: 32,
            value: 35,
          },
          {
            index: 33,
            value: 14,
          },
          {
            index: 34,
            value: 15,
          },
          {
            index: 35,
            value: 3,
          },
          {
            index: 36,
            value: 17,
          },
          {
            index: 37,
            value: 39,
          },
          {
            index: 38,
            value: 6,
          },
          {
            index: 39,
            value: 43,
          },
          {
            index: 40,
            value: 30,
          },
          {
            index: 41,
            value: 53,
          },
          {
            index: 42,
            value: 8,
          },
          {
            index: 43,
            value: 13,
          },
          {
            index: 44,
            value: 50,
          },
          {
            index: 45,
            value: 49,
          },
          {
            index: 46,
            value: 19,
          },
          {
            index: 47,
            value: 40,
          },
          {
            index: 48,
            value: 28,
          },
          {
            index: 49,
            value: 31,
          },
          {
            index: 50,
            value: 38,
          },
          {
            index: 51,
            value: 0,
          },
        ],
      },
    },
  },
  {
    status: 200,
    body: {
      status: 200,
      msg: 'Practice round',
      data: {
        opponentName: 'Love Startegy',
        opponentScore: 3840,
        secrets: [
          {
            index: 0,
            value: 26,
          },
          {
            index: 1,
            value: 15,
          },
          {
            index: 2,
            value: 34,
          },
          {
            index: 3,
            value: 23,
          },
          {
            index: 4,
            value: 39,
          },
          {
            index: 5,
            value: 4,
          },
          {
            index: 6,
            value: 27,
          },
          {
            index: 7,
            value: 11,
          },
          {
            index: 8,
            value: 5,
          },
          {
            index: 9,
            value: 21,
          },
          {
            index: 10,
            value: 29,
          },
          {
            index: 11,
            value: 47,
          },
          {
            index: 12,
            value: 49,
          },
          {
            index: 13,
            value: 10,
          },
          {
            index: 14,
            value: 3,
          },
          {
            index: 15,
            value: 2,
          },
          {
            index: 16,
            value: 53,
          },
          {
            index: 17,
            value: 43,
          },
          {
            index: 18,
            value: 22,
          },
          {
            index: 19,
            value: 16,
          },
          {
            index: 20,
            value: 19,
          },
          {
            index: 21,
            value: 41,
          },
          {
            index: 22,
            value: 35,
          },
          {
            index: 23,
            value: 13,
          },
          {
            index: 24,
            value: 6,
          },
          {
            index: 25,
            value: 30,
          },
          {
            index: 26,
            value: 37,
          },
          {
            index: 27,
            value: 46,
          },
          {
            index: 28,
            value: 48,
          },
          {
            index: 29,
            value: 40,
          },
          {
            index: 30,
            value: 7,
          },
          {
            index: 31,
            value: 36,
          },
          {
            index: 32,
            value: 18,
          },
          {
            index: 33,
            value: 33,
          },
          {
            index: 34,
            value: 38,
          },
          {
            index: 35,
            value: 44,
          },
          {
            index: 36,
            value: 0,
          },
          {
            index: 37,
            value: 25,
          },
          {
            index: 38,
            value: 45,
          },
          {
            index: 39,
            value: 51,
          },
          {
            index: 40,
            value: 24,
          },
          {
            index: 41,
            value: 8,
          },
          {
            index: 42,
            value: 20,
          },
          {
            index: 43,
            value: 9,
          },
          {
            index: 44,
            value: 17,
          },
          {
            index: 45,
            value: 1,
          },
          {
            index: 46,
            value: 50,
          },
          {
            index: 47,
            value: 31,
          },
          {
            index: 48,
            value: 52,
          },
          {
            index: 49,
            value: 12,
          },
          {
            index: 50,
            value: 28,
          },
          {
            index: 51,
            value: 42,
          },
        ],
      },
    },
  },
  {
    status: 200,
    body: {
      status: 200,
      msg: 'Practice round',
      data: {
        opponentName: 'wowza',
        opponentScore: 3320,
        secrets: [
          {
            index: 0,
            value: 33,
          },
          {
            index: 1,
            value: 22,
          },
          {
            index: 2,
            value: 19,
          },
          {
            index: 3,
            value: 0,
          },
          {
            index: 4,
            value: 8,
          },
          {
            index: 5,
            value: 38,
          },
          {
            index: 6,
            value: 2,
          },
          {
            index: 7,
            value: 52,
          },
          {
            index: 8,
            value: 27,
          },
          {
            index: 9,
            value: 18,
          },
          {
            index: 10,
            value: 45,
          },
          {
            index: 11,
            value: 47,
          },
          {
            index: 12,
            value: 35,
          },
          {
            index: 13,
            value: 43,
          },
          {
            index: 14,
            value: 25,
          },
          {
            index: 15,
            value: 3,
          },
          {
            index: 16,
            value: 13,
          },
          {
            index: 17,
            value: 32,
          },
          {
            index: 18,
            value: 10,
          },
          {
            index: 19,
            value: 46,
          },
          {
            index: 20,
            value: 14,
          },
          {
            index: 21,
            value: 1,
          },
          {
            index: 22,
            value: 51,
          },
          {
            index: 23,
            value: 17,
          },
          {
            index: 24,
            value: 29,
          },
          {
            index: 25,
            value: 37,
          },
          {
            index: 26,
            value: 34,
          },
          {
            index: 27,
            value: 49,
          },
          {
            index: 28,
            value: 40,
          },
          {
            index: 29,
            value: 24,
          },
          {
            index: 30,
            value: 30,
          },
          {
            index: 31,
            value: 23,
          },
          {
            index: 32,
            value: 26,
          },
          {
            index: 33,
            value: 50,
          },
          {
            index: 34,
            value: 7,
          },
          {
            index: 35,
            value: 12,
          },
          {
            index: 36,
            value: 20,
          },
          {
            index: 37,
            value: 5,
          },
          {
            index: 38,
            value: 42,
          },
          {
            index: 39,
            value: 31,
          },
          {
            index: 40,
            value: 53,
          },
          {
            index: 41,
            value: 39,
          },
          {
            index: 42,
            value: 21,
          },
          {
            index: 43,
            value: 41,
          },
          {
            index: 44,
            value: 48,
          },
          {
            index: 45,
            value: 28,
          },
          {
            index: 46,
            value: 36,
          },
          {
            index: 47,
            value: 11,
          },
          {
            index: 48,
            value: 6,
          },
          {
            index: 49,
            value: 16,
          },
          {
            index: 50,
            value: 9,
          },
          {
            index: 51,
            value: 44,
          },
        ],
      },
    },
  },
  {
    status: 200,
    body: {
      status: 200,
      msg: 'Practice round',
      data: {
        opponentName: 'Levis',
        opponentScore: 4320,
        secrets: [
          {
            index: 0,
            value: 52,
          },
          {
            index: 1,
            value: 19,
          },
          {
            index: 2,
            value: 31,
          },
          {
            index: 3,
            value: 37,
          },
          {
            index: 4,
            value: 13,
          },
          {
            index: 5,
            value: 18,
          },
          {
            index: 6,
            value: 47,
          },
          {
            index: 7,
            value: 32,
          },
          {
            index: 8,
            value: 15,
          },
          {
            index: 9,
            value: 1,
          },
          {
            index: 10,
            value: 17,
          },
          {
            index: 11,
            value: 9,
          },
          {
            index: 12,
            value: 49,
          },
          {
            index: 13,
            value: 20,
          },
          {
            index: 14,
            value: 35,
          },
          {
            index: 15,
            value: 4,
          },
          {
            index: 16,
            value: 45,
          },
          {
            index: 17,
            value: 2,
          },
          {
            index: 18,
            value: 50,
          },
          {
            index: 19,
            value: 48,
          },
          {
            index: 20,
            value: 36,
          },
          {
            index: 21,
            value: 43,
          },
          {
            index: 22,
            value: 6,
          },
          {
            index: 23,
            value: 41,
          },
          {
            index: 24,
            value: 3,
          },
          {
            index: 25,
            value: 28,
          },
          {
            index: 26,
            value: 40,
          },
          {
            index: 27,
            value: 0,
          },
          {
            index: 28,
            value: 11,
          },
          {
            index: 29,
            value: 44,
          },
          {
            index: 30,
            value: 16,
          },
          {
            index: 31,
            value: 26,
          },
          {
            index: 32,
            value: 29,
          },
          {
            index: 33,
            value: 12,
          },
          {
            index: 34,
            value: 14,
          },
          {
            index: 35,
            value: 38,
          },
          {
            index: 36,
            value: 34,
          },
          {
            index: 37,
            value: 5,
          },
          {
            index: 38,
            value: 10,
          },
          {
            index: 39,
            value: 30,
          },
          {
            index: 40,
            value: 8,
          },
          {
            index: 41,
            value: 39,
          },
          {
            index: 42,
            value: 51,
          },
          {
            index: 43,
            value: 53,
          },
          {
            index: 44,
            value: 33,
          },
          {
            index: 45,
            value: 7,
          },
          {
            index: 46,
            value: 22,
          },
          {
            index: 47,
            value: 25,
          },
          {
            index: 48,
            value: 27,
          },
          {
            index: 49,
            value: 23,
          },
          {
            index: 50,
            value: 42,
          },
          {
            index: 51,
            value: 46,
          },
        ],
      },
    },
  },
  {
    status: 200,
    body: {
      status: 200,
      msg: 'Practice round',
      data: {
        opponentName: 'Jason B',
        opponentScore: 3730,
        secrets: [
          {
            index: 0,
            value: 17,
          },
          {
            index: 1,
            value: 38,
          },
          {
            index: 2,
            value: 21,
          },
          {
            index: 3,
            value: 48,
          },
          {
            index: 4,
            value: 22,
          },
          {
            index: 5,
            value: 5,
          },
          {
            index: 6,
            value: 26,
          },
          {
            index: 7,
            value: 42,
          },
          {
            index: 8,
            value: 37,
          },
          {
            index: 9,
            value: 30,
          },
          {
            index: 10,
            value: 49,
          },
          {
            index: 11,
            value: 23,
          },
          {
            index: 12,
            value: 39,
          },
          {
            index: 13,
            value: 27,
          },
          {
            index: 14,
            value: 9,
          },
          {
            index: 15,
            value: 25,
          },
          {
            index: 16,
            value: 1,
          },
          {
            index: 17,
            value: 7,
          },
          {
            index: 18,
            value: 46,
          },
          {
            index: 19,
            value: 13,
          },
          {
            index: 20,
            value: 14,
          },
          {
            index: 21,
            value: 32,
          },
          {
            index: 22,
            value: 53,
          },
          {
            index: 23,
            value: 51,
          },
          {
            index: 24,
            value: 10,
          },
          {
            index: 25,
            value: 31,
          },
          {
            index: 26,
            value: 44,
          },
          {
            index: 27,
            value: 36,
          },
          {
            index: 28,
            value: 34,
          },
          {
            index: 29,
            value: 50,
          },
          {
            index: 30,
            value: 33,
          },
          {
            index: 31,
            value: 4,
          },
          {
            index: 32,
            value: 18,
          },
          {
            index: 33,
            value: 16,
          },
          {
            index: 34,
            value: 6,
          },
          {
            index: 35,
            value: 52,
          },
          {
            index: 36,
            value: 12,
          },
          {
            index: 37,
            value: 47,
          },
          {
            index: 38,
            value: 43,
          },
          {
            index: 39,
            value: 28,
          },
          {
            index: 40,
            value: 29,
          },
          {
            index: 41,
            value: 8,
          },
          {
            index: 42,
            value: 11,
          },
          {
            index: 43,
            value: 40,
          },
          {
            index: 44,
            value: 35,
          },
          {
            index: 45,
            value: 24,
          },
          {
            index: 46,
            value: 0,
          },
          {
            index: 47,
            value: 2,
          },
          {
            index: 48,
            value: 3,
          },
          {
            index: 49,
            value: 41,
          },
          {
            index: 50,
            value: 45,
          },
          {
            index: 51,
            value: 20,
          },
        ],
      },
    },
  },
  {
    status: 200,
    body: {
      status: 200,
      msg: 'Practice round',
      data: {
        opponentName: 'Jason B',
        opponentScore: 4140,
        secrets: [
          {
            index: 0,
            value: 39,
          },
          {
            index: 1,
            value: 27,
          },
          {
            index: 2,
            value: 41,
          },
          {
            index: 3,
            value: 47,
          },
          {
            index: 4,
            value: 48,
          },
          {
            index: 5,
            value: 22,
          },
          {
            index: 6,
            value: 15,
          },
          {
            index: 7,
            value: 35,
          },
          {
            index: 8,
            value: 5,
          },
          {
            index: 9,
            value: 17,
          },
          {
            index: 10,
            value: 26,
          },
          {
            index: 11,
            value: 23,
          },
          {
            index: 12,
            value: 49,
          },
          {
            index: 13,
            value: 21,
          },
          {
            index: 14,
            value: 24,
          },
          {
            index: 15,
            value: 0,
          },
          {
            index: 16,
            value: 1,
          },
          {
            index: 17,
            value: 28,
          },
          {
            index: 18,
            value: 3,
          },
          {
            index: 19,
            value: 11,
          },
          {
            index: 20,
            value: 44,
          },
          {
            index: 21,
            value: 16,
          },
          {
            index: 22,
            value: 52,
          },
          {
            index: 23,
            value: 25,
          },
          {
            index: 24,
            value: 9,
          },
          {
            index: 25,
            value: 51,
          },
          {
            index: 26,
            value: 53,
          },
          {
            index: 27,
            value: 29,
          },
          {
            index: 28,
            value: 31,
          },
          {
            index: 29,
            value: 46,
          },
          {
            index: 30,
            value: 40,
          },
          {
            index: 31,
            value: 13,
          },
          {
            index: 32,
            value: 32,
          },
          {
            index: 33,
            value: 36,
          },
          {
            index: 34,
            value: 20,
          },
          {
            index: 35,
            value: 38,
          },
          {
            index: 36,
            value: 30,
          },
          {
            index: 37,
            value: 8,
          },
          {
            index: 38,
            value: 18,
          },
          {
            index: 39,
            value: 19,
          },
          {
            index: 40,
            value: 33,
          },
          {
            index: 41,
            value: 34,
          },
          {
            index: 42,
            value: 43,
          },
          {
            index: 43,
            value: 12,
          },
          {
            index: 44,
            value: 4,
          },
          {
            index: 45,
            value: 45,
          },
          {
            index: 46,
            value: 6,
          },
          {
            index: 47,
            value: 42,
          },
          {
            index: 48,
            value: 2,
          },
          {
            index: 49,
            value: 7,
          },
          {
            index: 50,
            value: 50,
          },
          {
            index: 51,
            value: 10,
          },
        ],
      },
    },
  },
  {
    status: 200,
    body: {
      status: 200,
      msg: 'Practice round',
      data: {
        opponentName: 'cryptonator',
        opponentScore: 3410,
        secrets: [
          {
            index: 0,
            value: 23,
          },
          {
            index: 1,
            value: 53,
          },
          {
            index: 2,
            value: 5,
          },
          {
            index: 3,
            value: 45,
          },
          {
            index: 4,
            value: 41,
          },
          {
            index: 5,
            value: 20,
          },
          {
            index: 6,
            value: 12,
          },
          {
            index: 7,
            value: 14,
          },
          {
            index: 8,
            value: 11,
          },
          {
            index: 9,
            value: 17,
          },
          {
            index: 10,
            value: 49,
          },
          {
            index: 11,
            value: 28,
          },
          {
            index: 12,
            value: 10,
          },
          {
            index: 13,
            value: 34,
          },
          {
            index: 14,
            value: 40,
          },
          {
            index: 15,
            value: 29,
          },
          {
            index: 16,
            value: 46,
          },
          {
            index: 17,
            value: 33,
          },
          {
            index: 18,
            value: 7,
          },
          {
            index: 19,
            value: 19,
          },
          {
            index: 20,
            value: 51,
          },
          {
            index: 21,
            value: 31,
          },
          {
            index: 22,
            value: 22,
          },
          {
            index: 23,
            value: 6,
          },
          {
            index: 24,
            value: 26,
          },
          {
            index: 25,
            value: 18,
          },
          {
            index: 26,
            value: 44,
          },
          {
            index: 27,
            value: 21,
          },
          {
            index: 28,
            value: 37,
          },
          {
            index: 29,
            value: 13,
          },
          {
            index: 30,
            value: 1,
          },
          {
            index: 31,
            value: 8,
          },
          {
            index: 32,
            value: 24,
          },
          {
            index: 33,
            value: 42,
          },
          {
            index: 34,
            value: 9,
          },
          {
            index: 35,
            value: 32,
          },
          {
            index: 36,
            value: 3,
          },
          {
            index: 37,
            value: 48,
          },
          {
            index: 38,
            value: 47,
          },
          {
            index: 39,
            value: 15,
          },
          {
            index: 40,
            value: 30,
          },
          {
            index: 41,
            value: 16,
          },
          {
            index: 42,
            value: 39,
          },
          {
            index: 43,
            value: 35,
          },
          {
            index: 44,
            value: 50,
          },
          {
            index: 45,
            value: 25,
          },
          {
            index: 46,
            value: 2,
          },
          {
            index: 47,
            value: 0,
          },
          {
            index: 48,
            value: 52,
          },
          {
            index: 49,
            value: 43,
          },
          {
            index: 50,
            value: 38,
          },
          {
            index: 51,
            value: 36,
          },
        ],
      },
    },
  },
  {
    status: 200,
    body: {
      status: 200,
      msg: 'Practice round',
      data: {
        opponentName: 'THE KING',
        opponentScore: 3620,
        secrets: [
          {
            index: 0,
            value: 53,
          },
          {
            index: 1,
            value: 44,
          },
          {
            index: 2,
            value: 49,
          },
          {
            index: 3,
            value: 32,
          },
          {
            index: 4,
            value: 19,
          },
          {
            index: 5,
            value: 38,
          },
          {
            index: 6,
            value: 42,
          },
          {
            index: 7,
            value: 27,
          },
          {
            index: 8,
            value: 33,
          },
          {
            index: 9,
            value: 17,
          },
          {
            index: 10,
            value: 10,
          },
          {
            index: 11,
            value: 0,
          },
          {
            index: 12,
            value: 30,
          },
          {
            index: 13,
            value: 31,
          },
          {
            index: 14,
            value: 12,
          },
          {
            index: 15,
            value: 51,
          },
          {
            index: 16,
            value: 4,
          },
          {
            index: 17,
            value: 18,
          },
          {
            index: 18,
            value: 6,
          },
          {
            index: 19,
            value: 24,
          },
          {
            index: 20,
            value: 37,
          },
          {
            index: 21,
            value: 48,
          },
          {
            index: 22,
            value: 25,
          },
          {
            index: 23,
            value: 5,
          },
          {
            index: 24,
            value: 36,
          },
          {
            index: 25,
            value: 45,
          },
          {
            index: 26,
            value: 2,
          },
          {
            index: 27,
            value: 11,
          },
          {
            index: 28,
            value: 39,
          },
          {
            index: 29,
            value: 26,
          },
          {
            index: 30,
            value: 14,
          },
          {
            index: 31,
            value: 52,
          },
          {
            index: 32,
            value: 15,
          },
          {
            index: 33,
            value: 34,
          },
          {
            index: 34,
            value: 1,
          },
          {
            index: 35,
            value: 35,
          },
          {
            index: 36,
            value: 23,
          },
          {
            index: 37,
            value: 7,
          },
          {
            index: 38,
            value: 41,
          },
          {
            index: 39,
            value: 3,
          },
          {
            index: 40,
            value: 8,
          },
          {
            index: 41,
            value: 13,
          },
          {
            index: 42,
            value: 47,
          },
          {
            index: 43,
            value: 43,
          },
          {
            index: 44,
            value: 28,
          },
          {
            index: 45,
            value: 9,
          },
          {
            index: 46,
            value: 22,
          },
          {
            index: 47,
            value: 29,
          },
          {
            index: 48,
            value: 46,
          },
          {
            index: 49,
            value: 40,
          },
          {
            index: 50,
            value: 50,
          },
          {
            index: 51,
            value: 21,
          },
        ],
      },
    },
  },
  {
    status: 200,
    body: {
      status: 200,
      msg: 'Practice round',
      data: {
        opponentName: 'lacoicd',
        opponentScore: 4520,
        secrets: [
          {
            index: 0,
            value: 6,
          },
          {
            index: 1,
            value: 49,
          },
          {
            index: 2,
            value: 15,
          },
          {
            index: 3,
            value: 14,
          },
          {
            index: 4,
            value: 53,
          },
          {
            index: 5,
            value: 11,
          },
          {
            index: 6,
            value: 4,
          },
          {
            index: 7,
            value: 47,
          },
          {
            index: 8,
            value: 21,
          },
          {
            index: 9,
            value: 39,
          },
          {
            index: 10,
            value: 25,
          },
          {
            index: 11,
            value: 44,
          },
          {
            index: 12,
            value: 19,
          },
          {
            index: 13,
            value: 24,
          },
          {
            index: 14,
            value: 29,
          },
          {
            index: 15,
            value: 20,
          },
          {
            index: 16,
            value: 2,
          },
          {
            index: 17,
            value: 42,
          },
          {
            index: 18,
            value: 50,
          },
          {
            index: 19,
            value: 13,
          },
          {
            index: 20,
            value: 8,
          },
          {
            index: 21,
            value: 52,
          },
          {
            index: 22,
            value: 7,
          },
          {
            index: 23,
            value: 9,
          },
          {
            index: 24,
            value: 45,
          },
          {
            index: 25,
            value: 18,
          },
          {
            index: 26,
            value: 51,
          },
          {
            index: 27,
            value: 23,
          },
          {
            index: 28,
            value: 48,
          },
          {
            index: 29,
            value: 43,
          },
          {
            index: 30,
            value: 46,
          },
          {
            index: 31,
            value: 40,
          },
          {
            index: 32,
            value: 30,
          },
          {
            index: 33,
            value: 41,
          },
          {
            index: 34,
            value: 28,
          },
          {
            index: 35,
            value: 1,
          },
          {
            index: 36,
            value: 0,
          },
          {
            index: 37,
            value: 31,
          },
          {
            index: 38,
            value: 37,
          },
          {
            index: 39,
            value: 5,
          },
          {
            index: 40,
            value: 16,
          },
          {
            index: 41,
            value: 36,
          },
          {
            index: 42,
            value: 34,
          },
          {
            index: 43,
            value: 22,
          },
          {
            index: 44,
            value: 3,
          },
          {
            index: 45,
            value: 10,
          },
          {
            index: 46,
            value: 35,
          },
          {
            index: 47,
            value: 33,
          },
          {
            index: 48,
            value: 32,
          },
          {
            index: 49,
            value: 26,
          },
          {
            index: 50,
            value: 17,
          },
          {
            index: 51,
            value: 38,
          },
        ],
      },
    },
  },
  {
    status: 200,
    body: {
      status: 200,
      msg: 'Practice round',
      data: {
        opponentName: 'DaleChe',
        opponentScore: 4320,
        secrets: [
          {
            index: 0,
            value: 49,
          },
          {
            index: 1,
            value: 52,
          },
          {
            index: 2,
            value: 41,
          },
          {
            index: 3,
            value: 2,
          },
          {
            index: 4,
            value: 17,
          },
          {
            index: 5,
            value: 24,
          },
          {
            index: 6,
            value: 51,
          },
          {
            index: 7,
            value: 44,
          },
          {
            index: 8,
            value: 30,
          },
          {
            index: 9,
            value: 45,
          },
          {
            index: 10,
            value: 10,
          },
          {
            index: 11,
            value: 14,
          },
          {
            index: 12,
            value: 4,
          },
          {
            index: 13,
            value: 47,
          },
          {
            index: 14,
            value: 26,
          },
          {
            index: 15,
            value: 6,
          },
          {
            index: 16,
            value: 35,
          },
          {
            index: 17,
            value: 25,
          },
          {
            index: 18,
            value: 50,
          },
          {
            index: 19,
            value: 36,
          },
          {
            index: 20,
            value: 13,
          },
          {
            index: 21,
            value: 16,
          },
          {
            index: 22,
            value: 22,
          },
          {
            index: 23,
            value: 7,
          },
          {
            index: 24,
            value: 11,
          },
          {
            index: 25,
            value: 9,
          },
          {
            index: 26,
            value: 38,
          },
          {
            index: 27,
            value: 31,
          },
          {
            index: 28,
            value: 53,
          },
          {
            index: 29,
            value: 46,
          },
          {
            index: 30,
            value: 12,
          },
          {
            index: 31,
            value: 19,
          },
          {
            index: 32,
            value: 43,
          },
          {
            index: 33,
            value: 18,
          },
          {
            index: 34,
            value: 37,
          },
          {
            index: 35,
            value: 34,
          },
          {
            index: 36,
            value: 28,
          },
          {
            index: 37,
            value: 40,
          },
          {
            index: 38,
            value: 5,
          },
          {
            index: 39,
            value: 32,
          },
          {
            index: 40,
            value: 33,
          },
          {
            index: 41,
            value: 23,
          },
          {
            index: 42,
            value: 20,
          },
          {
            index: 43,
            value: 8,
          },
          {
            index: 44,
            value: 0,
          },
          {
            index: 45,
            value: 27,
          },
          {
            index: 46,
            value: 21,
          },
          {
            index: 47,
            value: 1,
          },
          {
            index: 48,
            value: 15,
          },
          {
            index: 49,
            value: 48,
          },
          {
            index: 50,
            value: 29,
          },
          {
            index: 51,
            value: 39,
          },
        ],
      },
    },
  },
  {
    status: 200,
    body: {
      status: 200,
      msg: 'Practice round',
      data: {
        opponentName: 'wizard0777',
        opponentScore: 890,
        secrets: [
          {
            index: 0,
            value: 30,
          },
          {
            index: 1,
            value: 11,
          },
          {
            index: 2,
            value: 2,
          },
          {
            index: 3,
            value: 31,
          },
          {
            index: 4,
            value: 25,
          },
          {
            index: 5,
            value: 47,
          },
          {
            index: 6,
            value: 7,
          },
          {
            index: 7,
            value: 12,
          },
          {
            index: 8,
            value: 34,
          },
          {
            index: 9,
            value: 19,
          },
          {
            index: 10,
            value: 9,
          },
          {
            index: 11,
            value: 14,
          },
          {
            index: 12,
            value: 5,
          },
          {
            index: 13,
            value: 20,
          },
          {
            index: 14,
            value: 13,
          },
          {
            index: 15,
            value: 6,
          },
          {
            index: 16,
            value: 28,
          },
          {
            index: 17,
            value: 4,
          },
          {
            index: 18,
            value: 23,
          },
          {
            index: 19,
            value: 24,
          },
          {
            index: 20,
            value: 22,
          },
          {
            index: 21,
            value: 53,
          },
          {
            index: 22,
            value: 42,
          },
          {
            index: 23,
            value: 45,
          },
          {
            index: 24,
            value: 33,
          },
          {
            index: 25,
            value: 3,
          },
          {
            index: 26,
            value: 44,
          },
          {
            index: 27,
            value: 43,
          },
          {
            index: 28,
            value: 51,
          },
          {
            index: 29,
            value: 27,
          },
          {
            index: 30,
            value: 29,
          },
          {
            index: 31,
            value: 36,
          },
          {
            index: 32,
            value: 41,
          },
          {
            index: 33,
            value: 35,
          },
          {
            index: 34,
            value: 39,
          },
          {
            index: 35,
            value: 16,
          },
          {
            index: 36,
            value: 52,
          },
          {
            index: 37,
            value: 1,
          },
          {
            index: 38,
            value: 21,
          },
          {
            index: 39,
            value: 38,
          },
          {
            index: 40,
            value: 49,
          },
          {
            index: 41,
            value: 37,
          },
          {
            index: 42,
            value: 17,
          },
          {
            index: 43,
            value: 15,
          },
          {
            index: 44,
            value: 46,
          },
          {
            index: 45,
            value: 0,
          },
          {
            index: 46,
            value: 8,
          },
          {
            index: 47,
            value: 32,
          },
          {
            index: 48,
            value: 10,
          },
          {
            index: 49,
            value: 40,
          },
          {
            index: 50,
            value: 50,
          },
          {
            index: 51,
            value: 26,
          },
        ],
      },
    },
  },
  {
    status: 200,
    body: {
      status: 200,
      msg: 'Practice round',
      data: {
        opponentName: 'AguM99',
        opponentScore: 4120,
        secrets: [
          {
            index: 0,
            value: 9,
          },
          {
            index: 1,
            value: 4,
          },
          {
            index: 2,
            value: 52,
          },
          {
            index: 3,
            value: 20,
          },
          {
            index: 4,
            value: 3,
          },
          {
            index: 5,
            value: 5,
          },
          {
            index: 6,
            value: 47,
          },
          {
            index: 7,
            value: 2,
          },
          {
            index: 8,
            value: 51,
          },
          {
            index: 9,
            value: 29,
          },
          {
            index: 10,
            value: 39,
          },
          {
            index: 11,
            value: 1,
          },
          {
            index: 12,
            value: 26,
          },
          {
            index: 13,
            value: 19,
          },
          {
            index: 14,
            value: 11,
          },
          {
            index: 15,
            value: 14,
          },
          {
            index: 16,
            value: 48,
          },
          {
            index: 17,
            value: 23,
          },
          {
            index: 18,
            value: 43,
          },
          {
            index: 19,
            value: 30,
          },
          {
            index: 20,
            value: 10,
          },
          {
            index: 21,
            value: 41,
          },
          {
            index: 22,
            value: 28,
          },
          {
            index: 23,
            value: 13,
          },
          {
            index: 24,
            value: 37,
          },
          {
            index: 25,
            value: 36,
          },
          {
            index: 26,
            value: 32,
          },
          {
            index: 27,
            value: 7,
          },
          {
            index: 28,
            value: 40,
          },
          {
            index: 29,
            value: 16,
          },
          {
            index: 30,
            value: 22,
          },
          {
            index: 31,
            value: 34,
          },
          {
            index: 32,
            value: 31,
          },
          {
            index: 33,
            value: 21,
          },
          {
            index: 34,
            value: 27,
          },
          {
            index: 35,
            value: 50,
          },
          {
            index: 36,
            value: 0,
          },
          {
            index: 37,
            value: 45,
          },
          {
            index: 38,
            value: 24,
          },
          {
            index: 39,
            value: 15,
          },
          {
            index: 40,
            value: 38,
          },
          {
            index: 41,
            value: 6,
          },
          {
            index: 42,
            value: 18,
          },
          {
            index: 43,
            value: 12,
          },
          {
            index: 44,
            value: 49,
          },
          {
            index: 45,
            value: 17,
          },
          {
            index: 46,
            value: 53,
          },
          {
            index: 47,
            value: 25,
          },
          {
            index: 48,
            value: 42,
          },
          {
            index: 49,
            value: 8,
          },
          {
            index: 50,
            value: 46,
          },
          {
            index: 51,
            value: 33,
          },
        ],
      },
    },
  },
  {
    status: 200,
    body: {
      status: 200,
      msg: 'Practice round',
      data: {
        opponentName: 'joeydefay',
        opponentScore: 2180,
        secrets: [
          {
            index: 0,
            value: 46,
          },
          {
            index: 1,
            value: 35,
          },
          {
            index: 2,
            value: 31,
          },
          {
            index: 3,
            value: 43,
          },
          {
            index: 4,
            value: 13,
          },
          {
            index: 5,
            value: 4,
          },
          {
            index: 6,
            value: 15,
          },
          {
            index: 7,
            value: 41,
          },
          {
            index: 8,
            value: 14,
          },
          {
            index: 9,
            value: 45,
          },
          {
            index: 10,
            value: 39,
          },
          {
            index: 11,
            value: 21,
          },
          {
            index: 12,
            value: 16,
          },
          {
            index: 13,
            value: 0,
          },
          {
            index: 14,
            value: 7,
          },
          {
            index: 15,
            value: 52,
          },
          {
            index: 16,
            value: 30,
          },
          {
            index: 17,
            value: 3,
          },
          {
            index: 18,
            value: 12,
          },
          {
            index: 19,
            value: 8,
          },
          {
            index: 20,
            value: 29,
          },
          {
            index: 21,
            value: 2,
          },
          {
            index: 22,
            value: 49,
          },
          {
            index: 23,
            value: 34,
          },
          {
            index: 24,
            value: 19,
          },
          {
            index: 25,
            value: 50,
          },
          {
            index: 26,
            value: 20,
          },
          {
            index: 27,
            value: 1,
          },
          {
            index: 28,
            value: 37,
          },
          {
            index: 29,
            value: 32,
          },
          {
            index: 30,
            value: 33,
          },
          {
            index: 31,
            value: 38,
          },
          {
            index: 32,
            value: 47,
          },
          {
            index: 33,
            value: 11,
          },
          {
            index: 34,
            value: 24,
          },
          {
            index: 35,
            value: 40,
          },
          {
            index: 36,
            value: 22,
          },
          {
            index: 37,
            value: 9,
          },
          {
            index: 38,
            value: 51,
          },
          {
            index: 39,
            value: 27,
          },
          {
            index: 40,
            value: 10,
          },
          {
            index: 41,
            value: 26,
          },
          {
            index: 42,
            value: 44,
          },
          {
            index: 43,
            value: 23,
          },
          {
            index: 44,
            value: 53,
          },
          {
            index: 45,
            value: 28,
          },
          {
            index: 46,
            value: 6,
          },
          {
            index: 47,
            value: 48,
          },
          {
            index: 48,
            value: 36,
          },
          {
            index: 49,
            value: 18,
          },
          {
            index: 50,
            value: 25,
          },
          {
            index: 51,
            value: 5,
          },
        ],
      },
    },
  },
  {
    status: 200,
    body: {
      status: 200,
      msg: 'Practice round',
      data: {
        opponentName: 'wowza',
        opponentScore: 4020,
        secrets: [
          {
            index: 0,
            value: 48,
          },
          {
            index: 1,
            value: 8,
          },
          {
            index: 2,
            value: 50,
          },
          {
            index: 3,
            value: 32,
          },
          {
            index: 4,
            value: 31,
          },
          {
            index: 5,
            value: 37,
          },
          {
            index: 6,
            value: 7,
          },
          {
            index: 7,
            value: 52,
          },
          {
            index: 8,
            value: 46,
          },
          {
            index: 9,
            value: 47,
          },
          {
            index: 10,
            value: 25,
          },
          {
            index: 11,
            value: 0,
          },
          {
            index: 12,
            value: 34,
          },
          {
            index: 13,
            value: 18,
          },
          {
            index: 14,
            value: 29,
          },
          {
            index: 15,
            value: 20,
          },
          {
            index: 16,
            value: 42,
          },
          {
            index: 17,
            value: 16,
          },
          {
            index: 18,
            value: 43,
          },
          {
            index: 19,
            value: 2,
          },
          {
            index: 20,
            value: 11,
          },
          {
            index: 21,
            value: 1,
          },
          {
            index: 22,
            value: 38,
          },
          {
            index: 23,
            value: 15,
          },
          {
            index: 24,
            value: 14,
          },
          {
            index: 25,
            value: 36,
          },
          {
            index: 26,
            value: 22,
          },
          {
            index: 27,
            value: 23,
          },
          {
            index: 28,
            value: 28,
          },
          {
            index: 29,
            value: 3,
          },
          {
            index: 30,
            value: 26,
          },
          {
            index: 31,
            value: 49,
          },
          {
            index: 32,
            value: 40,
          },
          {
            index: 33,
            value: 9,
          },
          {
            index: 34,
            value: 5,
          },
          {
            index: 35,
            value: 17,
          },
          {
            index: 36,
            value: 30,
          },
          {
            index: 37,
            value: 4,
          },
          {
            index: 38,
            value: 27,
          },
          {
            index: 39,
            value: 39,
          },
          {
            index: 40,
            value: 21,
          },
          {
            index: 41,
            value: 51,
          },
          {
            index: 42,
            value: 24,
          },
          {
            index: 43,
            value: 44,
          },
          {
            index: 44,
            value: 35,
          },
          {
            index: 45,
            value: 6,
          },
          {
            index: 46,
            value: 41,
          },
          {
            index: 47,
            value: 12,
          },
          {
            index: 48,
            value: 53,
          },
          {
            index: 49,
            value: 45,
          },
          {
            index: 50,
            value: 10,
          },
          {
            index: 51,
            value: 13,
          },
        ],
      },
    },
  },
];
